import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { InscripcionConvenioService } from '../services/inscripcion-convenio.service';
import { UsuarioService } from '../services/usuario.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-inscripcion-convenio',
  templateUrl: './inscripcion-convenio.component.html',
  styleUrls: ['./inscripcion-convenio.component.css']
})
export class InscripcionConvenioComponent implements OnInit {

  public domainInfo: any = {};
  public canValidateAutentika = true;
  public todayDate = this.getTodayIsoDate();

  public sellers: any[] = [];
  public loadingSellers = false;
  public isCartFromUrl = false;
  public sellerLockedFromCart: any = null;

  public loading = true;
  public loadingSubmit = false;
  public creatingCartSubscription = false;
  public updatingCartStep = false;
  public loadingCartFromUrl = false;
  public restoringCartFromUrl = false;
  public convenioDisponible = true;
  public showSuccessMessage = false;
  public showSuccessPaymentScreen = false;
  public showFailedPaymentScreen = false;
  public loadingPaymentReturn = false;
  public paymentStatusResponse: any = null;
  public paymentReturnMessage = '';
  public paymentReturnProviderName = '';

  public currentStep = 1;

  public steps: any = {
    seleccionPlan: true,
    titular: false,
    beneficiarios: false,
    planTerminos: false,
    validacion: false,
    pago: false,
    resumen: false
  };

  public inscripcionForm!: FormGroup;
  public beneficiarioForm!: FormGroup;

  public mostrarFormularioBeneficiario = false;
  public mostrarModalLimpiar = false;
  public indexBeneficiarioEditando: number | null = null;
  public cantidadBeneficiariosOpciones: number[] = [1, 2, 3, 4, 5, 6, 7];
  public mostrarDetallePrecioTitular = false;
  public mostrarDetallePrecioPlanTerminos = false;
  public showTermsModal = false;
  public termsScrolledToBottom = false;
  public checkingTitularPlanExist = false;
  public titularRutPlanValidationMessage = '';
  private lastTitularPlanValidationKey = '';
  private lastTitularPlanValidationValid: boolean | null = null;
  private lastTitularPlanValidationErrorKey = '';
  private lastTitularPlanValidationMessage = '';

  // Validación automática RUT + plan
  private titularRutValidationTimeout: any = null;
  private readonly TITULAR_RUT_VALIDATION_DELAY = 500;

  /**
   * Permite reconocer que la pestaña salió hacia Mercado Pago.
   * La marca se conserva aunque el navegador restaure la página
   * desde el Back/Forward Cache.
   */
  private readonly MERCADO_PAGO_REDIRECT_SESSION_KEY =
    'almamedis_mercado_pago_redirecting';

  public termsAndConditions: Array<{ title: string; paragraphs: string[]; bullets?: string[] }> = [
    {
      title: 'Términos y Condiciones de Contratación del Servicio AlmaMedis',
      paragraphs: [
        'AlmaMedis — Servicio de Telemedicina',
        'Al seleccionar la opción “Acepto los términos y condiciones”, el usuario declara haber leído, comprendido y aceptado en su totalidad las condiciones de contratación y uso del servicio de telemedicina AlmaMedis (en adelante, “AlmaMedis” o “el Servicio”), contenidas en el presente documento.'
      ]
    },
    {
      title: '1. Objeto',
      paragraphs: [
        'El presente documento regula la contratación, uso y condiciones comerciales aplicables al servicio de telemedicina prestado por AlmaMedis a través de sus plataformas y canales habilitados, así como los derechos y obligaciones del titular y de sus beneficiarios.'
      ]
    },
    {
      title: '2. Contratación del Plan',
      paragraphs: [
        'La contratación se realizará conforme al plan seleccionado por el usuario, incluyendo su valor, prestaciones, especialidades disponibles, topes de atención, vigencia y demás condiciones comerciales informadas antes de confirmar la suscripción.',
        'El usuario podrá revisar el detalle del plan antes de autorizar el pago.',
        'Los planes ofrecidos por AlmaMedis tienen una vigencia anual, sin perjuicio de que su cobro se realiza mediante cuotas mensuales, conforme se detalla en la cláusula 4 siguiente.'
      ]
    },
    {
      title: '3. Titular y Beneficiarios',
      paragraphs: [
        'El servicio podrá ser utilizado por el titular y por los beneficiarios registrados, de acuerdo con las condiciones y límites establecidos en el plan contratado.',
        'El usuario declara que la información proporcionada es verdadera, completa y actualizada, y que cuenta con autorización para registrar a los beneficiarios incorporados al plan.'
      ]
    },
    {
      title: '4. Vigencia, Pago y Renovación Automática',
      paragraphs: [
        'El plan contratado tiene una vigencia anual. No obstante lo anterior, el valor total del plan se cobrará en cuotas mensuales, mediante el medio de pago registrado por el usuario, durante toda la vigencia del plan.',
        'El usuario autoriza expresamente a AlmaMedis y al proveedor de pagos correspondiente a procesar el cobro mensual del plan mediante el medio de pago registrado, de forma recurrente y automática.',
        'Al término de cada periodo anual de vigencia, la suscripción se renovará automáticamente por un nuevo periodo de igual duración, y se continuará cobrando mensualmente, salvo que el usuario solicite su cancelación conforme al procedimiento establecido en la cláusula 10 siguiente, con anterioridad a la fecha de renovación.'
      ]
    },
    {
      title: '5. Ajuste de Precios',
      paragraphs: [
        'El valor de las cuotas mensuales podrá ser ajustado por AlmaMedis conforme a la variación del Índice de Precios al Consumidor (IPC) u otro indicador que lo reemplace, dicho ajuste podrá aplicarse, especialmente, en los procesos de renovación automática del plan señalados en la cláusula 4.',
        'Todo ajuste de precio será informado al titular del plan con la anticipación mínima señalada en la cláusula 11 (Modificaciones del Plan), de manera que este pueda evaluar la continuidad o cancelación de su suscripción antes de que el nuevo valor entre en vigencia.'
      ]
    },
    {
      title: '6. Incumplimiento de Pago y Suspensión del Servicio',
      paragraphs: [
        'En caso de rechazo, vencimiento, mora o cualquier imposibilidad de procesar el cobro mensual, AlmaMedis podrá suspender temporalmente el acceso a los beneficios del plan respecto del titular y de sus beneficiarios, hasta que la situación de pago sea regularizada.',
        'Si el no pago persiste o se repite conforme a los plazos y condiciones que AlmaMedis informe a través de sus canales habilitados, AlmaMedis podrá proceder a la suspensión definitiva del servicio y a la terminación de la suscripción, sin perjuicio de las obligaciones de pago ya devengadas por el usuario.'
      ]
    },
    {
      title: '7. Cobertura y Topes del Plan',
      paragraphs: [
        'Las atenciones estarán sujetas a las especialidades, cantidades, topes anuales y demás coberturas indicadas en el detalle del plan.',
        'Los topes podrán ser individuales o compartidos entre el titular y sus beneficiarios, según la configuración del plan contratado.',
        'Las prestaciones no utilizadas durante el periodo correspondiente no serán acumulables, salvo que las condiciones particulares del plan indiquen expresamente lo contrario.'
      ]
    },
    {
      title: '8. Prestaciones de Telemedicina',
      paragraphs: [
        'Las atenciones serán realizadas a distancia mediante las plataformas y canales habilitados por AlmaMedis.',
        'La telemedicina no reemplaza una atención presencial cuando el profesional determine que esta es necesaria. Tampoco corresponde utilizar el servicio ante una urgencia o emergencia médica. En dichos casos, el paciente deberá acudir inmediatamente a un servicio de urgencia o comunicarse con los servicios de emergencia correspondientes.',
        'La contratación del plan no garantiza un diagnóstico, tratamiento o resultado médico específico. Las decisiones clínicas serán adoptadas exclusivamente por el profesional de salud, de acuerdo con los antecedentes disponibles y su criterio profesional.',
        'El usuario y sus beneficiarios comprenden y aceptan que las consultas correspondientes a una determinada especialidad podrán ser realizadas por médicos especialistas en dicha área o por médicos debidamente capacitados y facultados para efectuar atenciones propias de esa especialidad, sin que ello implique necesariamente que el profesional tratante ostente el título de especialista.',
        'Antes de cada atención podrán solicitarse las autorizaciones y consentimientos requeridos para realizar la prestación de salud a distancia.'
      ]
    },
    {
      title: '9. Disponibilidad del Servicio',
      paragraphs: [
        'La disponibilidad de profesionales, horarios y especialidades podrá variar según la oferta vigente, la ubicación del paciente, las condiciones del plan y la capacidad operativa de la plataforma.',
        'AlmaMedis realizará esfuerzos razonables para mantener la continuidad del servicio, sin perjuicio de interrupciones ocasionadas por mantenimiento, fallas de conectividad, problemas tecnológicos o situaciones de fuerza mayor.'
      ]
    },
    {
      title: '10. Cancelación de la Suscripción',
      paragraphs: [
        'El usuario podrá solicitar la cancelación de la suscripción a través de los canales habilitados por AlmaMedis.',
        'La cancelación impedirá la generación de nuevos cobros posteriores a su fecha efectiva. Las condiciones de uso del periodo ya pagado y la existencia de eventuales devoluciones se regirán por lo informado en el detalle del plan y por la normativa vigente.'
      ]
    },
    {
      title: '11. Restricciones de Recontratación',
      paragraphs: [
        'En caso de que el titular cancele o dé de baja su plan, no podrá contratar nuevamente el mismo plan sino hasta transcurrido un periodo mínimo de un (1) año, contado desde la fecha efectiva de cancelación.',
        'Asimismo, en caso de que un beneficiario sea eliminado del plan, dicho beneficiario no podrá ser reincorporado al mismo sino hasta el término de la vigencia del ciclo del plan al cual pertenecía al momento de su eliminación.'
      ]
    },
    {
      title: '12. Modificaciones del Plan',
      paragraphs: [
        'AlmaMedis podrá modificar las condiciones, coberturas o valores del servicio cuando existan razones comerciales, operativas o regulatorias que lo justifiquen.',
        'Las modificaciones relevantes, incluyendo los ajustes de precio señalados en la cláusula 5, serán informadas al usuario con al menos 30 días de anticipación y se aplicarán hacia el futuro, respetando los derechos establecidos por la legislación vigente.',
        'El usuario podrá eliminar beneficiarios de su plan, con la restricción de no poder incorporar nuevos beneficiarios hasta que finalice el ciclo de vigencia correspondiente.'
      ]
    },
    {
      title: '13. Datos Personales',
      paragraphs: [
        'El usuario autoriza el tratamiento de sus datos personales y de los datos de los beneficiarios para gestionar la suscripción, coordinar las atenciones, procesar los pagos, enviar comunicaciones relacionadas con el servicio y cumplir las obligaciones legales correspondientes.',
        'Los datos personales y de salud serán tratados conforme a la normativa vigente y a la Política de Privacidad de AlmaMedis.'
      ]
    },
    {
      title: '14. Aceptación',
      paragraphs: [
        'Al continuar con la contratación, el usuario declara que:'
      ],
      bullets: [
        'Es mayor de edad y tiene capacidad para contratar.',
        'Revisó el detalle, valor y condiciones del plan seleccionado, incluyendo su vigencia anual y su modalidad de cobro mensual.',
        'Autoriza el cobro recurrente y automático mediante el medio de pago registrado, incluyendo los ajustes de precio conforme a IPC informados según la cláusula 5.',
        'La información ingresada es correcta y corresponde al titular y sus beneficiarios.',
        'Conoce las limitaciones propias de una atención realizada mediante telemedicina, incluyendo que las consultas de especialidad podrán ser realizadas por médicos capacitados para dicho efecto y no necesariamente por un médico especialista en la materia.',
        'Conoce las consecuencias del no pago, incluyendo la eventual suspensión temporal o definitiva del servicio, así como las restricciones de recontratación señaladas en la cláusula 11.',
        'Acepta los presentes términos y condiciones y la Política de Privacidad de AlmaMedis.'
      ]
    }
  ];


  public planesDisponibles: any[] = [];

  public cartSubscriptionResponse: any = null;
  public cartSubscriptionPayload: any = null;
  public updateCartStepResponse: any = null;
  public cartFromUrlResponse: any = null;
  public paymentSubscriptionResponse: any = null;
  private lastCartPayloadHash = '';

  public autenticarData: any = {
    estado: 'PENDIENTE',
    link: 'https://validacion.ejemplo.cl/almamedis',
    qrGenerado: true
  };

  public areaCodes: any[] = [
    {
      cou_phone_code: '56',
      cou_flag: 'fi-cl',
      cou_min_phone: 9,
      cou_max_phone: 9
    },
    {
      cou_phone_code: '54',
      cou_flag: 'fi-ar',
      cou_min_phone: 10,
      cou_max_phone: 10
    },
    {
      cou_phone_code: '51',
      cou_flag: 'fi-pe',
      cou_min_phone: 9,
      cou_max_phone: 9
    }
  ];

  public selectedAreaCode: any = {
    cou_phone_code: '56',
    cou_flag: 'fi-cl',
    cou_min_phone: 9,
    cou_max_phone: 9
  };

  public flagDropdownOpen = false;

  constructor(
    private fb: FormBuilder,
    private inscripcionService: InscripcionConvenioService,
    private usuarioService: UsuarioService,
    private route: ActivatedRoute
  ) { }

  /**
   * Se ejecuta cuando el navegador vuelve a mostrar esta página.
   *
   * En ambientes test/dev el navegador puede restaurar el componente
   * completo desde el Back/Forward Cache, conservando loadingSubmit=true.
   * Por eso no basta con ngOnInit(), ya que el componente puede no crearse
   * nuevamente al volver con la flecha del navegador.
   */
  @HostListener('window:pageshow', ['$event'])
  public onWindowPageShow(event: PageTransitionEvent): void {
    const wasRedirectingToMercadoPago =
      this.hasMercadoPagoRedirectSession();

    if (!event?.persisted && !wasRedirectingToMercadoPago) {
      return;
    }

    this.resetMercadoPagoRedirectState();
  }

  ngOnInit(): void {
    this.initForms();
    this.getCodPaises();
    this.setTelefonoValidators(this.selectedAreaCode);

    const tipoPago = this.getTipoPagoFromUrl();
    const preapprovalId = this.getPreapprovalIdFromUrl();
    const subscripcionId = this.getSubscripcionIdFromUrl();

    console.log('Retorno de pago detectado:', { tipoPago, preapprovalId, subscripcionId });

    if (tipoPago === 'mp' && preapprovalId) {
      this.procesarRetornoMercadoPago(preapprovalId);
      return;
    }

    if (tipoPago === 'vp' && subscripcionId) {
      this.procesarRetornoVirtualPos(subscripcionId);
      return;
    }

    /* Compatibilidad con el retorno antiguo de Mercado Pago que solo enviaba preapproval_id. */
    if (!tipoPago && preapprovalId) {
      this.procesarRetornoMercadoPago(preapprovalId);
      return;
    }

    this.initInscripcionConvenio();
  }

  private async initInscripcionConvenio(): Promise<void> {
    await this.getInfoConvenio();

    const tokenCart = this.getTokenCartFromUrl();

    if (tokenCart && this.convenioDisponible) {
      await this.cargarCarroSuscripcionDesdeUrl(tokenCart);
    }
  }

  // =========================================================
  // INIT
  // =========================================================

  private getSellers(): void {
    this.loadingSellers = true;

    this.inscripcionService.getSellers()
      .then((resp: any) => {
        const vendedores = Array.isArray(resp?.vendedores)
          ? resp.vendedores
          : Array.isArray(resp?.data)
            ? resp.data
            : Array.isArray(resp?.result)
              ? resp.result
              : Array.isArray(resp)
                ? resp
                : [];

        this.sellers = vendedores;
        this.ensureSellerFromCartExists();
      })
      .catch((error) => {
        console.error('Error al obtener vendedores:', error);
        this.sellers = [];
        this.ensureSellerFromCartExists();
      })
      .finally(() => {
        this.loadingSellers = false;
      });
  }

  private ensureSellerFromCartExists(): void {
    if (!this.sellerLockedFromCart?.use_id) {
      return;
    }

    const exists = this.sellers.some((seller: any) => {
      return Number(seller.use_id) === Number(this.sellerLockedFromCart.use_id);
    });

    if (!exists) {
      this.sellers.unshift(this.sellerLockedFromCart);
    }
  }

  public getSellerSelected(): any {
    const sellerId = this.titularForm.get('ejecutivo')?.value;

    if (this.sellerLockedFromCart?.use_id) {
      return this.sellerLockedFromCart;
    }

    if (!sellerId) {
      return null;
    }

    return this.sellers.find((seller: any) => {
      return Number(seller.use_id) === Number(sellerId);
    }) || null;
  }

  private initForms(): void {
    this.inscripcionForm = this.fb.group({
      titular: this.fb.group({
        plan: ['', Validators.required],
        rut: ['', [Validators.required, this.rutChilenoValidator.bind(this)]],
        email: ['', [Validators.required, this.emailFormatoValidator]],
        nombre: ['', [Validators.required, Validators.minLength(2)]],
        primerApellido: ['', [Validators.required, Validators.minLength(2)]],
        segundoApellido: [''],
        fechaNacimiento: ['', [Validators.required, this.fechaNoFuturaValidator]],
        telefonoCodigo: ['56', Validators.required],
        telefono: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
        direccion: [''],
        comuna: [''],
        ciudad: [''],
        ejecutivo: ['']
      }),

      beneficiariosDecision: this.fb.group({
        deseaAgregarBeneficiarios: [null, Validators.required],
        momentoAgregarBeneficiarios: [null],
        cantidadBeneficiariosDespues: [null],
        agregarBeneficiariosAhora: [false]
      }),

      beneficiarios: this.fb.array([]),

      planTerminos: this.fb.group({
        observaciones: [''],
        aceptaTerminos: [false, Validators.requiredTrue],
        aceptaDeclaracion: [false, Validators.requiredTrue]
      }),

      validacion: this.fb.group({
        identidadValidada: [false, Validators.requiredTrue],
        firmaCompletada: [false],
        autentikarInstanceId: [''],
        autentikarLink: [''],
        autentikarStatus: ['PENDIENTE']
      }),

      pago: this.fb.group({
        metodoPago: ['', Validators.required],
        autorizaPlanilla: [false, Validators.requiredTrue],
        pagoInscrito: [false],
        tokenPago: [''],
        preapprovalId: ['']
      })
    });

    this.beneficiarioForm = this.createBeneficiarioForm();

    this.titularForm.valueChanges.subscribe(() => {
      this.invalidateCartSubscription();
    });

    this.beneficiariosDecisionForm.valueChanges.subscribe(() => {
      this.invalidateCartSubscription();
    });
  }

  private async getInfoConvenio(): Promise<void> {
    this.loading = true;

    try {
      const result: any = await this.inscripcionService.getVerificarCanConvenio();

      this.domainInfo = result || {};
      this.convenioDisponible = this.domainInfo?.dataCustomer?.cus_can_convenio_particular === true
        || this.domainInfo?.cus_can_convenio_particular === true;

      this.canValidateAutentika = this.parseBoolean(
        this.domainInfo?.dataCustomer?.cus_can_validate_autentika,
        true
      );

      this.configurarValidacionAutentika();
      this.cargarPlanesDisponibles();

    } catch (error) {
      this.convenioDisponible = false;

    } finally {
      this.loading = false;
    }
  }

  private parseBoolean(value: any, defaultValue = false): boolean {
    if (value === null || value === undefined || value === '') {
      return defaultValue;
    }

    if (typeof value === 'boolean') {
      return value;
    }

    if (typeof value === 'number') {
      return value === 1;
    }

    const normalizedValue = value.toString().trim().toLowerCase();

    return ['true', '1', 'si', 'sí', 's', 'yes', 'y'].includes(normalizedValue);
  }

  private configurarValidacionAutentika(): void {
    const identidadValidadaCtrl = this.validacionForm?.get('identidadValidada');

    if (!identidadValidadaCtrl) {
      return;
    }

    if (this.canValidateAutentika) {
      identidadValidadaCtrl.setValidators([Validators.requiredTrue]);
    } else {
      identidadValidadaCtrl.clearValidators();

      this.validacionForm.patchValue({
        identidadValidada: true,
        firmaCompletada: true,
        autentikarStatus: 'SKIPPED'
      }, { emitEvent: false });
    }

    identidadValidadaCtrl.updateValueAndValidity({ emitEvent: false });
  }

  private cargarPlanesDisponibles(): void {
  const beneficios = this.domainInfo?.dataCustomerBenefits;

  if (!Array.isArray(beneficios)) {
    this.planesDisponibles = [];
    return;
  }

  this.planesDisponibles = beneficios
    .filter((plan: any) => Number(plan?.cus_ben_sta_id) === 14)
    .map((plan: any) => {
      return {
        ...plan,
        id: plan.cus_ben_id,
        nombre: plan.cus_ben_name
      };
    });
}

  private getCodPaises(): void {
    this.usuarioService.getCodPaises()
      .then((data: any) => {
        const codigos = Array.isArray(data)
          ? data
          : Array.isArray(data?.data)
            ? data.data
            : [];

        this.areaCodes = codigos.length > 0 ? codigos : this.areaCodes;

        const codigoChile = this.areaCodes.find((item: any) => {
          return String(item.cou_phone_code) === '56';
        });

        this.selectedAreaCode = codigoChile || this.selectedAreaCode;

        this.titularForm.patchValue({
          telefonoCodigo: this.selectedAreaCode.cou_phone_code
        }, { emitEvent: false });

        this.setTelefonoValidators(this.selectedAreaCode);
      })
      .catch(() => {
        this.setTelefonoValidators(this.selectedAreaCode);
      });
  }

  // =========================================================
  // GETTERS FORMULARIO
  // =========================================================

  get titularForm(): FormGroup {
    return this.inscripcionForm.get('titular') as FormGroup;
  }

  get beneficiariosDecisionForm(): FormGroup {
    return this.inscripcionForm.get('beneficiariosDecision') as FormGroup;
  }

  get planTerminosForm(): FormGroup {
    return this.inscripcionForm.get('planTerminos') as FormGroup;
  }

  get validacionForm(): FormGroup {
    return this.inscripcionForm.get('validacion') as FormGroup;
  }

  get pagoForm(): FormGroup {
    return this.inscripcionForm.get('pago') as FormGroup;
  }

  get beneficiarios(): FormArray {
    return this.inscripcionForm.get('beneficiarios') as FormArray;
  }

  // =========================================================
  // HEADER / LOGOS
  // =========================================================

  public getNombreConvenio(): string {
    return this.domainInfo?.dataCustomer?.cus_name
      || this.domainInfo?.convenio_nombre
      || this.domainInfo?.cus_name
      || this.domainInfo?.customer_name
      || 'Nombre del convenio';
  }

  public getLogoCliente(): string {
    return this.domainInfo?.logo_cliente
      || this.domainInfo?.cus_logo
      || this.domainInfo?.customer_logo
      || '';
  }

  public getLogoDefault(): string {
    return this.domainInfo?.dataDefault?.cus_url_image_web
      || this.domainInfo?.dataDefault?.cus_url_image_mobile
      || '';
  }

  public getLogoCustomer(): string {
    return this.domainInfo?.dataCustomer?.cus_url_image_web
      || this.domainInfo?.dataCustomer?.cus_url_image_mobile
      || '';
  }

  public showLogoCustomer(): boolean {
    const defaultId = this.domainInfo?.dataDefault?.cus_id;
    const customerId = this.domainInfo?.dataCustomer?.cus_id;

    return !!defaultId
      && !!customerId
      && defaultId !== customerId
      && !!this.getLogoCustomer();
  }

  public getNombreDefault(): string {
    return this.domainInfo?.dataDefault?.cus_name || 'AlmaMedis';
  }

  public getNombreCustomer(): string {
    return this.domainInfo?.dataCustomer?.cus_name || 'Convenio';
  }

  public getTelefonoCustomer(): string {
    const telefono = this.domainInfo?.dataCustomer?.cus_url_phone
      || '800 248 030';

    return this.formatTelefonoConvenio(telefono);
  }

  public getTelefonoCustomerHref(): string {
    const telefono = this.getTelefonoCustomer();

    if (!telefono) {
      return '';
    }

    const normalizedPhone = telefono
      .toString()
      .trim()
      .replace(/(?!^)\+/g, '')
      .replace(/[^0-9+]/g, '');

    return normalizedPhone ? `tel:${normalizedPhone}` : '';
  }

  public getCorreoCustomer(): string {
    return this.domainInfo?.dataCustomer?.cus_mail_contact
      || 'soporte@almamedis.cl';
  }

  public getCorreoCustomerHref(): string {
    const correo = this.getCorreoCustomer();
    return correo ? `mailto:${correo}` : '';
  }

  private formatTelefonoConvenio(telefono: any): string {
    const rawPhone = (telefono || '').toString().trim();

    if (!rawPhone) {
      return '';
    }

    const onlyDigits = rawPhone.replace(/\D/g, '');

    if (/^800\d{6}$/.test(onlyDigits)) {
      return `${onlyDigits.substring(0, 3)} ${onlyDigits.substring(3, 6)} ${onlyDigits.substring(6)}`;
    }

    return rawPhone;
  }

  // =========================================================
  // STEPS
  // =========================================================

  public getPagoStep(): number {
    return this.canValidateAutentika ? 6 : 5;
  }

  public getResumenStep(): number {
    return this.canValidateAutentika ? 7 : 6;
  }

  private normalizeStep(step: number): number {
    if (!this.canValidateAutentika && step === 6) {
      return this.getPagoStep();
    }

    return step;
  }

  private setStep(step: number): void {
    const normalizedStep = this.normalizeStep(step);
    const previousStep = this.currentStep;

    this.currentStep = normalizedStep;

    this.steps = {
      seleccionPlan: normalizedStep === 1,
      titular: normalizedStep === 2,
      beneficiarios: normalizedStep === 3,
      planTerminos: normalizedStep === 4,
      validacion: this.canValidateAutentika && normalizedStep === 5,
      pago: normalizedStep === this.getPagoStep(),
      resumen: normalizedStep === this.getResumenStep()
    };

    /*
      Cada vez que se entra al Step 2 desde otro paso, validamos
      automáticamente la combinación RUT + plan si ya existe un RUT.

      Esto cubre:
      - Step 1 -> Step 2
      - Step 3 -> Step 2
      - Step 4 -> Step 2
      - navegación desde el stepper

      No es necesario hacer foco y blur sobre el input.
    */
    if (normalizedStep === 2 && previousStep !== 2) {
      setTimeout(() => {
        this.validarRutPlanAlEntrarStep2();
      }, 0);
    }
  }

  public goToStep(step: number): void {
    /*
      Permite volver hacia atrás sin perder data.
      No permite saltar hacia adelante sin validar.
    */
    if (step < this.currentStep) {
      this.setStep(step);
    }
  }

  public goToStep1(): void {
    this.setStep(1);
  }

  public goToStep2(): void {
    this.setStep(2);
  }

  public goToStep3(): void {
    this.setStep(3);
  }

  public goToStep4(): void {
    this.setStep(4);
  }

  public goToStep5(): void {
    this.setStep(5);
  }

  public goToStep6(): void {
    this.setStep(6);
  }

  public goToPagoStep(): void {
    this.setStep(this.getPagoStep());
  }

  public goToResumen(): void {
    this.setStep(this.getResumenStep());
  }

  public prevStep(): void {
    if (this.currentStep > 1) {
      this.setStep(this.currentStep - 1);
    }
  }

  public nextStep(): void {
    if (this.currentStep === 1) {
      this.nextFromStep1();
      return;
    }

    if (this.currentStep === 2) {
      this.nextFromStep2();
      return;
    }

    if (this.currentStep === 3) {
      this.nextFromBeneficiarios();
      return;
    }

    if (this.steps.planTerminos) {
      this.nextFromStep3();
      return;
    }

    if (this.steps.validacion) {
      this.nextFromStep4();
      return;
    }

    if (this.steps.pago) {
      this.enviarFormulario();
    }
  }

  public nextFromStep1(): void {
    const planControl = this.titularForm.get('plan');

    planControl?.markAsTouched();

    if (!this.isStep1Valid()) {
      return;
    }

    /*
      setStep() se encarga de validar automáticamente
      RUT + plan al entrar al Step 2.
    */
    this.goToStep2();
  }

  public async nextFromStep2(): Promise<void> {
    this.markStep2Touched();

    if (!this.isStep2BaseValid()) {
      return;
    }

    const rutPlanValido = await this.validateTitularRutPlanExist();

    if (!rutPlanValido) {
      return;
    }

    this.goToStep3();
  }

  public async nextFromBeneficiarios(): Promise<void> {
    this.markBeneficiariosStepTouched();

    if (!this.isBeneficiariosStepValid()) {
      return;
    }

    if (!this.validarRutsBeneficiariosAntesDeEnviar()) {
      return;
    }

    const carroCreado = await this.crearCarroSuscripcionDesdeStep2();

    if (!carroCreado) {
      return;
    }

    this.goToStep4();
  }

  public async nextFromStep3(): Promise<void> {
    this.markStep3Touched();

    if (!this.isStep3Valid()) {
      return;
    }

    if (!this.cartSubscriptionResponse) {
      const carroCreado = await this.crearCarroSuscripcionDesdeStep2();

      if (!carroCreado) {
        return;
      }
    }

    const stepCart = this.canValidateAutentika ? 3 : 4;
    const carroActualizado = await this.actualizarCarroSuscripcionStep(stepCart);

    if (!carroActualizado) {
      return;
    }

    if (this.canValidateAutentika) {
      this.goToStep5();
      return;
    }

    this.setStep(this.getPagoStep());
  }

  public async nextFromStep4(): Promise<void> {
    this.markStep4Touched();

    if (!this.isStep4Valid()) {
      return;
    }

    const carroActualizado = await this.actualizarCarroSuscripcionStep(4);

    if (!carroActualizado) {
      return;
    }

    this.setStep(this.getPagoStep());
  }

  // =========================================================
  // VALIDACIONES STEPS
  // =========================================================

  private titularControls = [
    'rut',
    'email',
    'nombre',
    'primerApellido',
    'fechaNacimiento',
    'telefonoCodigo',
    'telefono'
  ];

  private markStep2Touched(): void {
    this.titularControls.forEach(controlName => {
      const control = this.titularForm.get(controlName);

      if (control && control.enabled) {
        control.markAsTouched();
      }
    });
  }

  private markBeneficiariosStepTouched(): void {
    this.beneficiariosDecisionForm.markAllAsTouched();
    this.beneficiarios.controls.forEach((control: AbstractControl) => control.markAllAsTouched());

    if (this.getAgregarBeneficiariosAhora() && this.mostrarFormularioBeneficiario) {
      this.beneficiarioForm.markAllAsTouched();
    }
  }

  private markStep3Touched(): void {
    this.planTerminosForm.markAllAsTouched();
  }

  private markStep4Touched(): void {
    this.validacionForm.markAllAsTouched();
  }

  private markStep5Touched(): void {
    this.pagoForm.markAllAsTouched();
  }

  public isStep1Valid(): boolean {
    return this.titularForm.get('plan')?.valid === true;
  }

  public isStep2Valid(): boolean {
    if (this.checkingTitularPlanExist) {
      return false;
    }

    return this.isStep2BaseValid()
      && this.isCurrentTitularPlanValidationValid();
  }

  private isStep2BaseValid(): boolean {
    return this.titularControls.every(controlName => {
      const control = this.titularForm.get(controlName);

      if (!control) {
        return false;
      }

      if (control.disabled) {
        return true;
      }

      if (controlName === 'rut') {
        const errors = { ...(control.errors || {}) };

        delete errors.titularPlanExiste;
        delete errors.titularPlanNoPermitido;
        delete errors.titularPlanValidationError;

        return Object.keys(errors).length === 0;
      }

      return control.valid;
    });
  }

  private isCurrentTitularPlanValidationValid(): boolean {
    const payload = this.buildBenPlanExistPayload();

    if (!payload.rut_ben || !payload.cus_ben_id) {
      return false;
    }

    const validationKey = this.getTitularPlanValidationKey(payload);

    return this.lastTitularPlanValidationKey === validationKey
      && this.lastTitularPlanValidationValid === true;
  }

  public isBeneficiariosStepValid(): boolean {
    const desea = this.getDeseaAgregarBeneficiarios();

    if (!desea) {
      return false;
    }

    if (desea === 'NO') {
      return true;
    }

    return !!this.getCantidadBeneficiariosDespuesSeleccionada();
  }

  public isStep3Valid(): boolean {
    return this.planTerminosForm.valid;
  }

  public isStep4Valid(): boolean {
    if (!this.canValidateAutentika) {
      return true;
    }

    return this.validacionForm.get('identidadValidada')?.value === true;
  }

  public isStep5Valid(): boolean {
    const metodoPago = this.pagoForm.get('metodoPago')?.value;
    const metodoDisponible = (metodoPago === 'MERCADO_PAGO' && this.canUseMercadoPago()) || (metodoPago === 'VIRTUAL_POS' && this.canUseVirtualPos());
    return metodoDisponible && this.pagoForm.get('autorizaPlanilla')?.value === true;
  }

  private getSubscriptionPaymentCustomer(): any {
    const cartData = this.cartFromUrlResponse?.data || this.cartFromUrlResponse?.cart || this.cartFromUrlResponse?.result || this.cartFromUrlResponse;
    return cartData?.customer || this.cartSubscriptionResponse?.customer || this.domainInfo?.dataCustomer || {};
  }

  public canUseMercadoPago(): boolean {
    return this.parseBoolean(this.getSubscriptionPaymentCustomer()?.cus_can_subscription_mp, false);
  }

  public canUseVirtualPos(): boolean {
    return this.parseBoolean(this.getSubscriptionPaymentCustomer()?.cus_can_subscription_vp, false);
  }

  public hasAvailablePaymentMethods(): boolean {
    return this.canUseMercadoPago() || this.canUseVirtualPos();
  }

  public campoInvalido(form: FormGroup, campo: string): boolean {
    const control = form.get(campo);
    return !!control && control.invalid && control.touched;
  }

  // =========================================================
  // PLANES
  // =========================================================

  public seleccionarPlan(plan: any): void {
  if (!plan) {
    return;
  }

  const planCtrl = this.titularForm.get('plan');

  const planActual = planCtrl?.value;

  const nuevoPlan =
    plan.id ||
    plan.cus_ben_id;

  /*
   * Solo invalidamos la validación RUT + PLAN
   * cuando realmente cambia el plan.
   *
   * Si el usuario vuelve al Step 1 y selecciona
   * exactamente el mismo plan, conservamos el
   * resultado anterior.
   */
  const cambioPlan =
    String(planActual || '') !==
    String(nuevoPlan || '');

  planCtrl?.setValue(nuevoPlan);

  planCtrl?.markAsTouched();

  if (cambioPlan) {
    this.resetTitularPlanValidationState();
  }
}

  public esPlanSeleccionado(plan: any): boolean {
    const planId = this.titularForm.get('plan')?.value;

    return String(planId) === String(plan?.id)
      || String(planId) === String(plan?.cus_ben_id);
  }

  public getPlanSeleccionado(): any {
    const planId = this.titularForm.get('plan')?.value;

    if (!planId) {
      return null;
    }

    return this.planesDisponibles.find((plan: any) => {
      return String(plan.cus_ben_id) === String(planId)
        || String(plan.id) === String(planId);
    }) || null;
  }

  public getEspecialidadesPlan(plan: any): any[] {
    if (!plan || !Array.isArray(plan.especialidades)) {
      return [];
    }

    return plan.especialidades;
  }

  public getEspecialidadesPlanSeleccionado(): any[] {
    return this.getEspecialidadesPlan(this.getPlanSeleccionado());
  }

  public getTextoTipoConsulta(especialidad: any): string {
    return especialidad?.spe_is_ondemand ? 'Atención inmediata' : 'Agendamiento';
  }

  public getPlanSubtitulo(plan: any): string {
    if (plan?.cus_ben_text_welcome) {
      return plan.cus_ben_text_welcome;
    }

    if (plan?.cus_ben_description) {
      return plan.cus_ben_description;
    }

    return 'Plan disponible para inscripción';
  }

  public getAgregarBeneficiariosAhora(): boolean {
    return this.getDeseaAgregarBeneficiarios() === 'SI';
  }

  public onAgregarBeneficiariosAhoraChange(): void {
    this.invalidateCartSubscription();
  }

  public getDeseaAgregarBeneficiarios(): string | null {
    return this.beneficiariosDecisionForm.get('deseaAgregarBeneficiarios')?.value || null;
  }

  public getMomentoAgregarBeneficiarios(): string | null {
    return this.beneficiariosDecisionForm.get('momentoAgregarBeneficiarios')?.value || null;
  }

  public getCantidadBeneficiariosDespuesSeleccionada(): number | null {
    const value = this.beneficiariosDecisionForm.get('cantidadBeneficiariosDespues')?.value;
    return value ? Number(value) : null;
  }

  public seleccionarDeseaAgregarBeneficiarios(opcion: 'SI' | 'NO'): void {
    if (opcion === 'NO') {
      this.beneficiariosDecisionForm.patchValue({
        deseaAgregarBeneficiarios: 'NO',
        momentoAgregarBeneficiarios: null,
        cantidadBeneficiariosDespues: null,
        agregarBeneficiariosAhora: false
      });

      this.limpiarBeneficiariosSlots();
      this.cerrarFormularioBeneficiario();
      this.invalidateCartSubscription();
      return;
    }

    this.beneficiariosDecisionForm.patchValue({
      deseaAgregarBeneficiarios: 'SI',
      momentoAgregarBeneficiarios: 'AHORA',
      agregarBeneficiariosAhora: true
    });

    const cantidadSeleccionada = this.getCantidadBeneficiariosDespuesSeleccionada();

    if (cantidadSeleccionada) {
      this.crearBeneficiariosSlots(cantidadSeleccionada);
    }

    this.cerrarFormularioBeneficiario();
    this.invalidateCartSubscription();
  }

  public seleccionarMomentoAgregarBeneficiarios(opcion: 'AHORA' | 'DESPUES'): void {
    this.beneficiariosDecisionForm.patchValue({
      momentoAgregarBeneficiarios: 'AHORA',
      agregarBeneficiariosAhora: true
    });

    this.cerrarFormularioBeneficiario();
    this.invalidateCartSubscription();
  }

  public seleccionarCantidadBeneficiariosDespues(cantidad: number): void {
    const cantidadNormalizada = Math.max(1, Number(cantidad || 0));

    this.beneficiariosDecisionForm.patchValue({
      deseaAgregarBeneficiarios: 'SI',
      momentoAgregarBeneficiarios: 'AHORA',
      cantidadBeneficiariosDespues: cantidadNormalizada,
      agregarBeneficiariosAhora: true
    });

    this.crearBeneficiariosSlots(cantidadNormalizada);
    this.cerrarFormularioBeneficiario();
    this.invalidateCartSubscription();
  }

  public isBeneficiariosAhoraFlow(): boolean {
    return this.getDeseaAgregarBeneficiarios() === 'SI'
      && !!this.getCantidadBeneficiariosDespuesSeleccionada();
  }

  public isBeneficiariosDespuesFlow(): boolean {
    return false;
  }

  public showInfoBeneficiariosPosterior(): boolean {
    return this.getDeseaAgregarBeneficiarios() === 'NO';
  }

  public getCantidadBeneficiariosActual(): number {
    if (this.getDeseaAgregarBeneficiarios() !== 'SI') {
      return 0;
    }

    return this.getCantidadBeneficiariosDespuesSeleccionada() || 0;
  }

  /**
   * Indica si el usuario seleccionó al menos un beneficiario
   * para incorporarlo al plan.
   *
   * Se utiliza en el Step 4 para mostrar u ocultar
   * la columna de consultas de beneficiarios.
   */
  public tieneBeneficiariosSeleccionados(): boolean {
    return this.getCantidadBeneficiariosActual() > 0;
  }

  /**
   * Formatea la cantidad de consultas de una especialidad.
   *
   * Regla:
   * - 0 / "0" / null / undefined / vacío => "Ilimitadas"
   * - cualquier número mayor a 0 => muestra la cantidad
   */
  public getTextoCantidadConsultas(value: any): string {
    if (
      value === null ||
      value === undefined ||
      value === ''
    ) {
      return 'Ilimitadas';
    }

    const cantidad = Number(value);

    if (isNaN(cantidad) || cantidad <= 0) {
      return 'Ilimitadas';
    }

    return String(cantidad);
  }
  public getTextoResumenTitularBeneficiarios(): string {
    const cantidadBeneficiarios = this.getCantidadBeneficiariosActual();

    if (!cantidadBeneficiarios || cantidadBeneficiarios <= 0) {
      return 'Titular';
    }

    return `Titular + ${cantidadBeneficiarios} ${cantidadBeneficiarios === 1 ? 'beneficiario' : 'beneficiarios'
      }`;
  }

  public getBeneficiariosCompletadosCount(): number {
    return this.getBeneficiariosCompletadosControls().length;
  }

  public isBeneficiarioSlotCompleto(index: number): boolean {
    const control = this.beneficiarios.at(index);

    if (!control) {
      return false;
    }

    return this.isBeneficiarioDataCompleto(control.value) && control.valid;
  }

  public getBeneficiarioSlotTitulo(index: number): string {
    return `Beneficiario ${index + 1}`;
  }

  public getPrecioTitularPlan(plan?: any): number {
    const planData = plan || this.getPlanSeleccionado();
    return this.toNumberPlan(planData?.cus_ben_price_titular);
  }

  public getPrecioCarga1Plan(plan?: any): number {
    const planData = plan || this.getPlanSeleccionado();
    return this.toNumberPlan(planData?.cus_ben_price_carga1);
  }

  public getPrecioCarga2Plan(plan?: any): number {
    const planData = plan || this.getPlanSeleccionado();
    return this.toNumberPlan(planData?.cus_ben_price_carga2);
  }

  public getTotalCargasPlan(plan?: any): number {
    const totalBeneficiarios = this.getCantidadBeneficiariosActual();

    if (totalBeneficiarios <= 0) {
      return 0;
    }

    let total = 0;

    if (totalBeneficiarios >= 1) {
      total += this.getPrecioCarga1Plan(plan);
    }

    if (totalBeneficiarios > 1) {
      total += (totalBeneficiarios - 1) * this.getPrecioCarga2Plan(plan);
    }

    return total;
  }

  public getTotalPlanMensual(plan?: any): number {
    return this.getPrecioTitularPlan(plan) + this.getTotalCargasPlan(plan);
  }

  public toggleDetallePrecioTitular(): void {
    this.mostrarDetallePrecioTitular = !this.mostrarDetallePrecioTitular;
  }

  public toggleDetallePrecioPlanTerminos(): void {
    this.mostrarDetallePrecioPlanTerminos = !this.mostrarDetallePrecioPlanTerminos;
  }

  public openTermsModal(): void {
    this.showTermsModal = true;
    this.termsScrolledToBottom = false;

    setTimeout(() => {
      this.checkTermsModalScrollInitialState();
    }, 0);
  }

  public closeTermsModal(): void {
    this.showTermsModal = false;
    this.termsScrolledToBottom = false;
  }

  public onTermsScroll(event: any): void {
    const element = event?.target;

    if (!element) {
      return;
    }

    this.termsScrolledToBottom = this.hasScrolledToBottom(element);
  }

  public acceptTermsFromModal(): void {
    /*
      El modal es solo informativo. La aceptación real de los términos
      se realiza con el checkbox visible en la card externa del Step 4.
    */
    this.closeTermsModal();
  }

  public onTermsExternalCheckboxChange(event: any): void {
    const checked = event?.target?.checked === true;

    this.planTerminosForm.patchValue({
      aceptaTerminos: checked,
      aceptaDeclaracion: checked
    });

    this.planTerminosForm.get('aceptaTerminos')?.markAsTouched();
    this.planTerminosForm.get('aceptaDeclaracion')?.markAsTouched();
    this.planTerminosForm.updateValueAndValidity();
  }

  public hasAcceptedTerms(): boolean {
    return this.planTerminosForm.get('aceptaTerminos')?.value === true
      && this.planTerminosForm.get('aceptaDeclaracion')?.value === true;
  }

  private checkTermsModalScrollInitialState(): void {
    const element = document.querySelector('.terms-modal-scroll') as HTMLElement;

    if (!element) {
      return;
    }

    this.termsScrolledToBottom = this.hasScrolledToBottom(element);
  }

  private hasScrolledToBottom(element: HTMLElement): boolean {
    const scrollPosition = element.scrollTop + element.clientHeight;
    const scrollHeight = element.scrollHeight;

    return scrollPosition >= scrollHeight - 6;
  }

  public getDetallePrecioPlanTerminos(): any[] {
    return this.getDetallePrecioTitular();
  }

  public getDetallePrecioTitular(): any[] {
    const detalle: any[] = [];

    detalle.push({
      label: 'Titular',
      amount: this.getPrecioTitularPlan()
    });

    const totalBeneficiarios = this.getCantidadBeneficiariosActual();

    for (let index = 0; index < totalBeneficiarios; index++) {
      detalle.push({
        label: `Beneficiario ${index + 1}`,
        amount: this.getAmountBeneficiario(index)
      });
    }

    return detalle;
  }

  public formatPrecioPlan(value: any): string {
    const numberValue = this.toNumberPlan(value);

    return numberValue.toLocaleString('es-CL', {
      style: 'currency',
      currency: 'CLP',
      maximumFractionDigits: 0
    });
  }

  public formatFechaPlan(value: any): string {
  if (!value) {
    return '—';
  }

  /*
   * Evitamos:
   *
   * new Date('2026-07-27')
   *
   * porque JavaScript interpreta YYYY-MM-DD como UTC
   * y en Chile puede terminar mostrando el día anterior.
   */

  if (typeof value === 'string') {
    const rawDate = value.trim().substring(0, 10);

    const match = rawDate.match(
      /^(\d{4})-(\d{2})-(\d{2})$/
    );

    if (match) {
      const year = Number(match[1]);
      const month = Number(match[2]);
      const day = Number(match[3]);

      const date = new Date(
        year,
        month - 1,
        day
      );

      return date.toLocaleDateString('es-CL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
  }

  /*
   * Fallback por si alguna función entrega
   * directamente un objeto Date.
   */
  const date =
    value instanceof Date
      ? value
      : new Date(value);

  if (isNaN(date.getTime())) {
    return '—';
  }

  return date.toLocaleDateString('es-CL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}

  public getFechaInicioVigenciaPlan(): string {
    // console.log('this.todayDate:', this.todayDate);
    return this.todayDate;
  }

  public getDiaFacturacionPlan(plan?: any): number | null {
    const planData = plan || this.getPlanSeleccionado();

    return this.getDayFromDateValue(
      planData?.cus_ben_fecha_facturacion
      || planData?.cus_ben_billing_date
      || planData?.fecha_facturacion
    );
  }

  public getTextoFechaFacturacionPlan(plan?: any): string {
    const diaFacturacion = this.getDiaFacturacionPlan(plan);

    if (!diaFacturacion) {
      return '—';
    }

    return `${diaFacturacion} de cada mes`;
  }

  public getFechaRenovacionAnualPlan(plan?: any): Date | null {
    const diaFacturacion = this.getDiaFacturacionPlan(plan);

    if (!diaFacturacion) {
      return null;
    }

    const inicioVigencia = this.getDateFromIsoString(this.getFechaInicioVigenciaPlan());

    if (!inicioVigencia) {
      return null;
    }

    const fechaBaseAnual = new Date(
      inicioVigencia.getFullYear() + 1,
      inicioVigencia.getMonth(),
      inicioVigencia.getDate()
    );

    let fechaRenovacion = this.buildDateWithBillingDay(
      fechaBaseAnual.getFullYear(),
      fechaBaseAnual.getMonth(),
      diaFacturacion
    );

    fechaBaseAnual.setHours(0, 0, 0, 0);
    fechaRenovacion.setHours(0, 0, 0, 0);

    if (fechaRenovacion < fechaBaseAnual) {
      fechaRenovacion = this.buildDateWithBillingDay(
        fechaBaseAnual.getFullYear(),
        fechaBaseAnual.getMonth() + 1,
        diaFacturacion
      );
    }

    return fechaRenovacion;
  }

  public getDiasProporcionalesPlan(plan?: any): number {
    const diaFacturacion = this.getDiaFacturacionPlan(plan);

    if (!diaFacturacion) {
      return 0;
    }

    const inicioVigencia = this.getDateFromIsoString(this.getFechaInicioVigenciaPlan());

    if (!inicioVigencia) {
      return 0;
    }

    const proximaFacturacion = this.getNextBillingDateFrom(inicioVigencia, diaFacturacion);

    inicioVigencia.setHours(0, 0, 0, 0);
    proximaFacturacion.setHours(0, 0, 0, 0);

    const diffTime = proximaFacturacion.getTime() - inicioVigencia.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return Math.max(diffDays, 0);
  }

  public getTextoPeriodoInicialPlan(plan?: any): string {
    const dias = this.getDiasProporcionalesPlan(plan);

    if (dias <= 0) {
      return 'La facturación inicia desde el ciclo mensual vigente.';
    }

    return `El primer pago considera ${dias} día(s) proporcionales hasta la primera fecha de facturación.`;
  }

  private getDateFromIsoString(value: any): Date | null {
    if (!value) {
      return null;
    }

    const raw = value.toString().substring(0, 10);
    const parts = raw.split('-');

    if (parts.length !== 3) {
      return null;
    }

    const year = Number(parts[0]);
    const month = Number(parts[1]);
    const day = Number(parts[2]);

    if (!year || !month || !day) {
      return null;
    }

    return new Date(year, month - 1, day);
  }

  private getDayFromDateValue(value: any): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (typeof value === 'number') {
      return this.normalizeBillingDay(value);
    }

    const raw = value.toString().trim();

    if (/^\d{1,2}$/.test(raw)) {
      return this.normalizeBillingDay(Number(raw));
    }

    let match = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);

    if (match) {
      return this.normalizeBillingDay(Number(match[3]));
    }

    match = raw.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})/);

    if (match) {
      return this.normalizeBillingDay(Number(match[1]));
    }

    const date = new Date(raw);

    if (!isNaN(date.getTime())) {
      return this.normalizeBillingDay(date.getDate());
    }

    return null;
  }

  private normalizeBillingDay(day: number): number | null {
    const normalizedDay = Number(day);

    if (isNaN(normalizedDay) || normalizedDay < 1 || normalizedDay > 31) {
      return null;
    }

    return normalizedDay;
  }

  private getLastDayOfMonth(year: number, monthIndex: number): number {
    return new Date(year, monthIndex + 1, 0).getDate();
  }

  private buildDateWithBillingDay(year: number, monthIndex: number, billingDay: number): Date {
    const lastDay = this.getLastDayOfMonth(year, monthIndex);
    const validDay = Math.min(billingDay, lastDay);

    return new Date(year, monthIndex, validDay);
  }

  private getNextBillingDateFrom(startDate: Date, billingDay: number): Date {
    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);

    let billingDate = this.buildDateWithBillingDay(
      start.getFullYear(),
      start.getMonth(),
      billingDay
    );

    billingDate.setHours(0, 0, 0, 0);

    if (billingDate < start) {
      billingDate = this.buildDateWithBillingDay(
        start.getFullYear(),
        start.getMonth() + 1,
        billingDay
      );
    }

    return billingDate;
  }

  private toNumberPlan(value: any): number {
    if (value === null || value === undefined || value === '') {
      return 0;
    }

    const numberValue = Number(value);

    return isNaN(numberValue) ? 0 : numberValue;
  }

  // =========================================================
  // VALIDACIONES INPUTS
  // =========================================================

  public allowOnlyLetters(event: KeyboardEvent): void {
    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ'´\s]*$/;

    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  public allowOnlyNumbers(event: KeyboardEvent): void {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  public allowOnlyRutChars(event: KeyboardEvent): void {
    const regex = /^[0-9kK.\-]$/;

    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  public async onRutBlur(): Promise<void> {
    const rutCtrl = this.titularForm.get('rut');

    if (!rutCtrl) {
      return;
    }

    /*
      Si había una validación automática pendiente por escritura,
      la cancelamos porque aquí validaremos inmediatamente.
    */
    this.clearTitularRutValidationTimeout();

    const rut = rutCtrl.value || '';
    const rutFormateado = this.formatRut(rut);

    rutCtrl.setValue(rutFormateado, { emitEvent: false });
    rutCtrl.markAsTouched();
    rutCtrl.updateValueAndValidity({ emitEvent: false });

    this.actualizarValidacionRutsBeneficiarios();

    await this.validateTitularRutPlanExist();
  }

  /**
   * Se ejecuta automáticamente cada vez que se entra al Step 2.
   * Si ya existe un RUT válido, vuelve a aplicar/consultar la
   * validación RUT + plan sin requerir foco ni blur en el input.
   */
  private async validarRutPlanAlEntrarStep2(): Promise<void> {
    const rutCtrl = this.titularForm.get('rut');

    if (!rutCtrl) {
      return;
    }

    this.clearTitularRutValidationTimeout();

    const rut = (rutCtrl.value || '').toString().trim();

    /*
      Si todavía no hay RUT, simplemente esperamos que el usuario
      lo escriba. onTitularRutInput() lo validará automáticamente.
    */
    if (!rut) {
      return;
    }

    const rutFormateado = this.formatRut(rut);

    rutCtrl.setValue(rutFormateado, { emitEvent: false });
    rutCtrl.updateValueAndValidity({ emitEvent: false });

    /*
      No consultamos backend si el RUT base es inválido.
    */
    if (
      rutCtrl.hasError('required') ||
      rutCtrl.hasError('rutInvalido')
    ) {
      rutCtrl.markAsTouched();
      return;
    }

    rutCtrl.markAsTouched();

    await this.validateTitularRutPlanExist();
  }

  /**
   * Al escribir el RUT:
   * 1. invalida el resultado anterior;
   * 2. espera 500 ms desde la última tecla;
   * 3. si el RUT ya es válido y existe un plan, consulta automáticamente.
   *
   * De esta forma el usuario no necesita hacer click fuera del input.
   */
  public onTitularRutInput(): void {
    this.resetTitularPlanValidationState();
    this.clearTitularRutValidationTimeout();

    const rutCtrl = this.titularForm.get('rut');

    if (!rutCtrl) {
      return;
    }

    rutCtrl.updateValueAndValidity({ emitEvent: false });

    /*
      Mientras el RUT esté incompleto o inválido no consultamos backend.
    */
    if (
      !rutCtrl.value ||
      rutCtrl.hasError('required') ||
      rutCtrl.hasError('rutInvalido')
    ) {
      return;
    }

    const planSeleccionado = this.getPlanSeleccionado();

    if (!planSeleccionado) {
      return;
    }

    this.titularRutValidationTimeout = setTimeout(async () => {
      /*
        Volvemos a verificar antes de consultar, porque el usuario
        pudo seguir escribiendo durante el delay.
      */
      const currentRutCtrl = this.titularForm.get('rut');

      if (
        !currentRutCtrl ||
        !currentRutCtrl.value ||
        currentRutCtrl.hasError('required') ||
        currentRutCtrl.hasError('rutInvalido') ||
        !this.getPlanSeleccionado()
      ) {
        return;
      }

      currentRutCtrl.markAsTouched();

      await this.validateTitularRutPlanExist();

    }, this.TITULAR_RUT_VALIDATION_DELAY);
  }

  private clearTitularRutValidationTimeout(): void {
    if (this.titularRutValidationTimeout) {
      clearTimeout(this.titularRutValidationTimeout);
      this.titularRutValidationTimeout = null;
    }
  }

  private resetTitularPlanValidationState(): void {
    this.lastTitularPlanValidationKey = '';
    this.lastTitularPlanValidationValid = null;
    this.lastTitularPlanValidationErrorKey = '';
    this.lastTitularPlanValidationMessage = '';
    this.clearTitularPlanExistErrors();
  }

  private clearTitularPlanExistErrors(): void {
    const rutCtrl = this.titularForm?.get('rut');

    this.titularRutPlanValidationMessage = '';

    if (!rutCtrl?.errors) {
      return;
    }

    const errors = { ...rutCtrl.errors };

    delete errors.titularPlanExiste;
    delete errors.titularPlanNoPermitido;
    delete errors.titularPlanValidationError;

    rutCtrl.setErrors(Object.keys(errors).length ? errors : null);
  }

  private setTitularPlanExistError(errorKey: string, message: string): void {
    const rutCtrl = this.titularForm.get('rut');

    if (!rutCtrl) {
      return;
    }

    this.titularRutPlanValidationMessage = message;

    rutCtrl.setErrors({
      ...(rutCtrl.errors || {}),
      [errorKey]: true
    });

    rutCtrl.markAsTouched();
  }

  public shouldShowTitularPlanValidationMessage(): boolean {
    const rutCtrl = this.titularForm.get('rut');

    if (!rutCtrl || !this.titularRutPlanValidationMessage) {
      return false;
    }

    return rutCtrl.touched && (
      rutCtrl.hasError('titularPlanExiste') ||
      rutCtrl.hasError('titularPlanNoPermitido') ||
      rutCtrl.hasError('titularPlanValidationError')
    );
  }

  private buildBenPlanExistPayload(): any {
    const planSeleccionado = this.getPlanSeleccionado();

    return {
      rut_ben: this.cleanRutForPayload(this.titularForm.get('rut')?.value),
      cus_ben_id: Number(
        planSeleccionado?.cus_ben_id ||
        planSeleccionado?.id ||
        this.titularForm.get('plan')?.value ||
        0
      )
    };
  }

  private getTitularPlanValidationKey(payload: any): string {
    return `${payload?.rut_ben || ''}|${payload?.cus_ben_id || ''}`;
  }

  private hasOnlyBaseRutErrors(): boolean {
    const rutCtrl = this.titularForm.get('rut');

    if (!rutCtrl?.errors) {
      return false;
    }

    const errors = { ...rutCtrl.errors };

    delete errors.titularPlanExiste;
    delete errors.titularPlanNoPermitido;
    delete errors.titularPlanValidationError;

    return Object.keys(errors).length > 0;
  }

  private cacheTitularPlanValidationResult(
    validationKey: string,
    valid: boolean,
    errorKey: string = '',
    message: string = ''
  ): void {
    this.lastTitularPlanValidationKey = validationKey;
    this.lastTitularPlanValidationValid = valid;
    this.lastTitularPlanValidationErrorKey = errorKey;
    this.lastTitularPlanValidationMessage = message;
  }

  public async validateTitularRutPlanExist(): Promise<boolean> {
    const rutCtrl = this.titularForm.get('rut');

    if (!rutCtrl) {
      return false;
    }

    this.clearTitularPlanExistErrors();
    rutCtrl.updateValueAndValidity({ emitEvent: false });

    if (this.hasOnlyBaseRutErrors()) {
      return false;
    }

    const payload = this.buildBenPlanExistPayload();

    if (!payload.rut_ben || !payload.cus_ben_id) {
      return false;
    }

    const validationKey = this.getTitularPlanValidationKey(payload);

    if (this.lastTitularPlanValidationKey === validationKey) {
      if (this.lastTitularPlanValidationValid === true) {
        return true;
      }

      if (this.lastTitularPlanValidationValid === false) {
        this.setTitularPlanExistError(
          this.lastTitularPlanValidationErrorKey || 'titularPlanValidationError',
          this.lastTitularPlanValidationMessage || 'El RUT ingresado no puede contratar este plan.'
        );

        return false;
      }
    }

    this.checkingTitularPlanExist = true;

    try {
      const response: any = await (this.inscripcionService as any).postBenPlanExist(payload);
      const validationResult = this.getBenPlanExistValidationResult(response);

      this.cacheTitularPlanValidationResult(
        validationKey,
        validationResult.valid,
        validationResult.errorKey,
        validationResult.message
      );

      if (!validationResult.valid) {
        this.setTitularPlanExistError(
          validationResult.errorKey,
          validationResult.message
        );

        return false;
      }

      return true;

    } catch (error) {
      console.error('Error postBenPlanExist:', error);

      const message = this.getBackendErrorMessage(
        error,
        'No fue posible validar si el RUT puede contratar este plan. Intenta nuevamente.'
      );

      this.cacheTitularPlanValidationResult(
        validationKey,
        false,
        'titularPlanValidationError',
        message
      );

      this.setTitularPlanExistError(
        'titularPlanValidationError',
        message
      );

      return false;

    } finally {
      this.checkingTitularPlanExist = false;
    }
  }

  private getBenPlanExistValidationResult(response: any): { valid: boolean; errorKey: string; message: string } {
    const data = response?.data !== undefined
      ? response.data
      : response?.result !== undefined
        ? response.result
        : response;

    const defaultExistsMessage = 'El RUT ingresado ya tiene este plan contratado.';
    const defaultNotAllowedMessage = 'El RUT ingresado no puede contratar este servicio.';
    const responseMessage = response?.message || data?.message || data?.msg || '';

    if (Array.isArray(data) && data.length > 0) {
      return {
        valid: false,
        errorKey: 'titularPlanExiste',
        message: responseMessage || defaultExistsMessage
      };
    }

    const exists = this.parseBooleanOptional(
      data?.exists ??
      data?.exist ??
      data?.ben_plan_exist ??
      data?.plan_exist ??
      data?.is_exist ??
      data?.hasPlan ??
      data?.alreadyExists ??
      response?.exists ??
      response?.exist
    );

    if (exists === true) {
      return {
        valid: false,
        errorKey: 'titularPlanExiste',
        message: responseMessage || defaultExistsMessage
      };
    }

    const canContract = this.parseBooleanOptional(
      data?.can_contract ??
      data?.canContract ??
      data?.puede_contratar ??
      data?.puedeContratar ??
      data?.canSubscribe ??
      data?.valid
    );

    if (canContract === false) {
      return {
        valid: false,
        errorKey: 'titularPlanNoPermitido',
        message: responseMessage || defaultNotAllowedMessage
      };
    }

    const ok = this.parseBooleanOptional(
      response?.ok ??
      response?.success ??
      data?.ok ??
      data?.success
    );

    if (ok === false) {
      return {
        valid: false,
        errorKey: 'titularPlanNoPermitido',
        message: responseMessage || defaultNotAllowedMessage
      };
    }

    return {
      valid: true,
      errorKey: '',
      message: ''
    };
  }

  private parseBooleanOptional(value: any): boolean | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (typeof value === 'boolean') {
      return value;
    }

    if (typeof value === 'number') {
      return value === 1;
    }

    const normalizedValue = value.toString().trim().toLowerCase();

    if (['true', '1', 'si', 'sí', 's', 'yes', 'y'].includes(normalizedValue)) {
      return true;
    }

    if (['false', '0', 'no', 'n'].includes(normalizedValue)) {
      return false;
    }

    return null;
  }

  public onBeneficiarioRutBlur(): void {
    const rutCtrl = this.beneficiarioForm.get('rut');

    if (!rutCtrl) {
      return;
    }

    const rut = rutCtrl.value || '';
    const rutFormateado = this.formatRut(rut);

    rutCtrl.setValue(rutFormateado, { emitEvent: false });
    rutCtrl.markAsTouched();
    rutCtrl.updateValueAndValidity();

    this.actualizarValidacionRutsBeneficiarios();
  }

  public rutChilenoValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (!value) {
      return null;
    }

    const rut = this.normalizeRut(value);

    if (rut.length < 2) {
      return { rutInvalido: true };
    }

    const cuerpo = rut.slice(0, -1);
    const dv = rut.slice(-1).toUpperCase();

    if (!/^\d+$/.test(cuerpo)) {
      return { rutInvalido: true };
    }

    let suma = 0;
    let multiplo = 2;

    for (let i = cuerpo.length - 1; i >= 0; i--) {
      suma += Number(cuerpo.charAt(i)) * multiplo;
      multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }

    const dvEsperadoNumero = 11 - (suma % 11);
    let dvEsperado = '';

    if (dvEsperadoNumero === 11) {
      dvEsperado = '0';
    } else if (dvEsperadoNumero === 10) {
      dvEsperado = 'K';
    } else {
      dvEsperado = String(dvEsperadoNumero);
    }

    return dv === dvEsperado ? null : { rutInvalido: true };
  }

  private beneficiarioRutUnicoModalValidator(control: AbstractControl): ValidationErrors | null {
    return this.validarRutBeneficiarioUnico(control.value, this.indexBeneficiarioEditando);
  }

  private beneficiarioRutUnicoArrayValidator(control: AbstractControl): ValidationErrors | null {
    const index = this.getIndexBeneficiarioControl(control);
    return this.validarRutBeneficiarioUnico(control.value, index);
  }

  private validarRutBeneficiarioUnico(rutValue: any, indexActual: number | null): ValidationErrors | null {
    const rutBeneficiario = this.normalizeRut(rutValue);

    if (!rutBeneficiario || rutBeneficiario.length < 2) {
      return null;
    }

    const rutTitular = this.normalizeRut(this.titularForm?.get('rut')?.value);

    if (rutTitular && rutBeneficiario === rutTitular) {
      return { rutIgualTitular: true };
    }

    const existeDuplicado = this.beneficiarios.controls.some((control: AbstractControl, index: number) => {
      if (indexActual !== null && index === indexActual) {
        return false;
      }

      const rutIngresado = this.normalizeRut(control.get('rut')?.value);

      return !!rutIngresado && rutIngresado === rutBeneficiario;
    });

    if (existeDuplicado) {
      return { rutBeneficiarioDuplicado: true };
    }

    return null;
  }

  private getIndexBeneficiarioControl(control: AbstractControl): number | null {
    if (!this.beneficiarios) {
      return null;
    }

    const index = this.beneficiarios.controls.findIndex((group: AbstractControl) => {
      return group.get('rut') === control;
    });

    return index >= 0 ? index : null;
  }

  private actualizarValidacionRutsBeneficiarios(): void {
    this.beneficiarioForm?.get('rut')?.updateValueAndValidity({ emitEvent: false });

    this.beneficiarios.controls.forEach((control: AbstractControl) => {
      control.get('rut')?.updateValueAndValidity({ emitEvent: false });
    });
  }

  private validarRutsBeneficiariosAntesDeEnviar(): boolean {
    this.actualizarValidacionRutsBeneficiarios();

    const tieneErrorRut = this.beneficiarios.controls.some((control: AbstractControl) => {
      const rutCtrl = control.get('rut');

      return !!rutCtrl &&
        (
          rutCtrl.hasError('rutIgualTitular') ||
          rutCtrl.hasError('rutBeneficiarioDuplicado')
        );
    });

    if (!tieneErrorRut) {
      return true;
    }

    this.beneficiarios.controls.forEach((control: AbstractControl) => {
      control.get('rut')?.markAsTouched();
    });

    Swal.fire({
      icon: 'warning',
      title: 'RUT de beneficiario no válido',
      text: 'El beneficiario no puede tener el mismo RUT del titular ni repetirse con otro beneficiario ingresado.',
      confirmButtonText: 'Aceptar'
    });

    return false;
  }

  public emailFormatoValidator(control: AbstractControl): ValidationErrors | null {
    const value = (control.value || '').toString().trim();

    if (!value) {
      return null;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    return emailRegex.test(value) ? null : { emailFormatoInvalido: true };
  }

  public fechaNoFuturaValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (!value) {
      return null;
    }

    const fechaIngresada = new Date(`${value}T00:00:00`);

    if (isNaN(fechaIngresada.getTime())) {
      return { fechaInvalida: true };
    }

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    return fechaIngresada > hoy ? { fechaMayorActual: true } : null;
  }

  private getTodayIsoDate(): string {
    const hoy = new Date();
    const year = hoy.getFullYear();
    const month = String(hoy.getMonth() + 1).padStart(2, '0');
    const day = String(hoy.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  private formatRut(rut: any): string {
    const clean = this.normalizeRut(rut);

    if (!clean) {
      return '';
    }

    if (clean.length === 1) {
      return clean;
    }

    const cuerpo = clean.slice(0, -1);
    const dv = clean.slice(-1);

    return `${cuerpo}-${dv}`;
  }

  private normalizeRut(rut: any): string {
    return (rut || '')
      .toString()
      .replace(/[^0-9kK]/g, '')
      .toUpperCase();
  }

  public onTelefonoInput(event: any): void {
    const value = (event.target.value || '').toString().replace(/\D/g, '');
    this.titularForm.get('telefono')?.setValue(value, { emitEvent: false });
    this.titularForm.get('telefono')?.markAsDirty();
    this.titularForm.get('telefono')?.updateValueAndValidity({ emitEvent: false });
  }

  public getTelefonoDigitsCount(): number {
    const telefono = this.titularForm.get('telefono')?.value || '';

    return telefono.toString().replace(/\D/g, '').length;
  }

  public getTelefonoMinDigits(): number {
    return Number(this.selectedAreaCode?.cou_min_phone || 8);
  }

  public getTelefonoMaxDigits(): number {
    return Number(this.selectedAreaCode?.cou_max_phone || 15);
  }

  public getTelefonoMissingDigits(): number {
    const minDigits = this.getTelefonoMinDigits();
    const currentDigits = this.getTelefonoDigitsCount();

    return Math.max(minDigits - currentDigits, 0);
  }

  public shouldShowTelefonoMissingMessage(): boolean {
    const telefonoCtrl = this.titularForm.get('telefono');

    if (!telefonoCtrl) {
      return false;
    }

    return this.getTelefonoDigitsCount() > 0
      && this.getTelefonoMissingDigits() > 0;
  }

  public getTelefonoRemainingMessage(): string {
    const missingDigits = this.getTelefonoMissingDigits();

    if (missingDigits <= 0) {
      return '';
    }

    const suffix = missingDigits === 1 ? 'número' : 'números';

    return `Te falta${missingDigits === 1 ? '' : 'n'} ${missingDigits} ${suffix} por ingresar.`;
  }

  // =========================================================
  // CÓDIGO DE ÁREA
  // =========================================================

  public toggleFlagDropdown(): void {
    this.flagDropdownOpen = !this.flagDropdownOpen;
  }

  public selectAreaCode(areaCode: any): void {
    this.selectedAreaCode = areaCode;

    this.titularForm.patchValue({
      telefonoCodigo: areaCode.cou_phone_code
    });

    this.flagDropdownOpen = false;
    this.setTelefonoValidators(areaCode);
  }

  public onAreaCodeChange(event: any): void {
    const selectedCode = event.target.value;

    const areaCode = this.areaCodes.find((item: any) => {
      return String(item.cou_phone_code) === String(selectedCode);
    });

    if (areaCode) {
      this.selectedAreaCode = areaCode;
      this.setTelefonoValidators(areaCode);
    }
  }

  private setTelefonoValidators(areaCode: any): void {
    const telefonoCtrl = this.titularForm.get('telefono');

    if (!telefonoCtrl) {
      return;
    }

    const minPhone = Number(areaCode?.cou_min_phone || 8);
    const maxPhone = Number(areaCode?.cou_max_phone || 15);

    telefonoCtrl.setValidators([
      Validators.required,
      Validators.pattern('^[0-9]*$'),
      Validators.minLength(minPhone),
      Validators.maxLength(maxPhone)
    ]);

    telefonoCtrl.updateValueAndValidity();
  }

  // =========================================================
  // BENEFICIARIOS
  // =========================================================

  private createBeneficiarioForm(): FormGroup {
    return this.fb.group({
      rut: [
        '',
        [
          Validators.required,
          this.rutChilenoValidator.bind(this),
          this.beneficiarioRutUnicoModalValidator.bind(this)
        ]
      ],
      email: ['', [Validators.required, this.emailFormatoValidator]],
      nombre: ['', [Validators.required, Validators.minLength(2)]],
      primerApellido: ['', [Validators.required, Validators.minLength(2)]],
      segundoApellido: [''],
      fechaNacimiento: ['', [Validators.required, this.fechaNoFuturaValidator]]
    });
  }

  private createBeneficiarioGroup(data?: any): FormGroup {
    return this.fb.group({
      rut: [
        data?.rut || '',
        [
          Validators.required,
          this.rutChilenoValidator.bind(this),
          this.beneficiarioRutUnicoArrayValidator.bind(this)
        ]
      ],
      email: [data?.email || '', [Validators.required, this.emailFormatoValidator]],
      nombre: [data?.nombre || '', [Validators.required, Validators.minLength(2)]],
      primerApellido: [data?.primerApellido || '', [Validators.required, Validators.minLength(2)]],
      segundoApellido: [data?.segundoApellido || ''],
      fechaNacimiento: [data?.fechaNacimiento || '', [Validators.required, this.fechaNoFuturaValidator]]
    });
  }

  private crearBeneficiariosSlots(cantidad: number): void {
    const totalSlots = Math.max(0, Number(cantidad || 0));

    while (this.beneficiarios.length < totalSlots) {
      this.beneficiarios.push(this.createBeneficiarioGroup());
    }

    while (this.beneficiarios.length > totalSlots) {
      this.beneficiarios.removeAt(this.beneficiarios.length - 1);
    }

    if (
      this.indexBeneficiarioEditando !== null
      && this.indexBeneficiarioEditando >= this.beneficiarios.length
    ) {
      this.cerrarFormularioBeneficiario();
    }
  }

  private limpiarBeneficiariosSlots(): void {
    while (this.beneficiarios.length > 0) {
      this.beneficiarios.removeAt(0);
    }
  }

  private isBeneficiarioDataCompleto(data: any): boolean {
    return !!(
      data?.rut
      && data?.nombre
      && data?.primerApellido
      && data?.email
      && data?.fechaNacimiento
    );
  }

  private getBeneficiariosCompletadosControls(): Array<{ control: AbstractControl; index: number }> {
    return this.beneficiarios.controls
      .map((control: AbstractControl, index: number) => ({ control, index }))
      .filter((item) => {
        return this.isBeneficiarioDataCompleto(item.control.value) && item.control.valid;
      });
  }

  public abrirFormularioAgregarBeneficiario(index?: number): void {
    const cantidadSeleccionada = this.getCantidadBeneficiariosDespuesSeleccionada();

    if (!cantidadSeleccionada) {
      this.beneficiariosDecisionForm.get('cantidadBeneficiariosDespues')?.markAsTouched();
      return;
    }

    if (this.beneficiarios.length !== cantidadSeleccionada) {
      this.crearBeneficiariosSlots(cantidadSeleccionada);
    }

    const slotIndex = index !== undefined && index !== null
      ? index
      : this.beneficiarios.controls.findIndex((control: AbstractControl) => !this.isBeneficiarioDataCompleto(control.value));

    this.indexBeneficiarioEditando = slotIndex >= 0 ? slotIndex : null;
    this.beneficiarioForm = this.createBeneficiarioForm();

    if (this.indexBeneficiarioEditando !== null) {
      const beneficiario = this.beneficiarios.at(this.indexBeneficiarioEditando)?.value;

      if (this.isBeneficiarioDataCompleto(beneficiario)) {
        this.beneficiarioForm.patchValue({
          rut: beneficiario.rut,
          email: beneficiario.email || '',
          nombre: beneficiario.nombre,
          primerApellido: beneficiario.primerApellido,
          segundoApellido: beneficiario.segundoApellido,
          fechaNacimiento: beneficiario.fechaNacimiento
        });
      }
    }

    this.mostrarFormularioBeneficiario = true;
  }

  public editarBeneficiario(index: number): void {
    this.abrirFormularioAgregarBeneficiario(index);
  }

  public cerrarFormularioBeneficiario(): void {
    this.mostrarFormularioBeneficiario = false;
    this.indexBeneficiarioEditando = null;
    this.beneficiarioForm.reset();
  }

  public guardarBeneficiario(): void {
    if (this.beneficiarioForm.invalid) {
      this.beneficiarioForm.markAllAsTouched();
      return;
    }

    const rutCtrl = this.beneficiarioForm.get('rut');

    if (
      rutCtrl?.hasError('rutIgualTitular') ||
      rutCtrl?.hasError('rutBeneficiarioDuplicado')
    ) {
      rutCtrl.markAsTouched();
      return;
    }

    const data = this.beneficiarioForm.value;

    if (this.indexBeneficiarioEditando !== null) {
      this.beneficiarios.at(this.indexBeneficiarioEditando).patchValue(data);
    } else {
      const firstEmptyIndex = this.beneficiarios.controls.findIndex((control: AbstractControl) => {
        return !this.isBeneficiarioDataCompleto(control.value);
      });

      if (firstEmptyIndex >= 0) {
        this.beneficiarios.at(firstEmptyIndex).patchValue(data);
      } else {
        this.beneficiarios.push(this.createBeneficiarioGroup(data));
        this.beneficiariosDecisionForm.patchValue({
          cantidadBeneficiariosDespues: this.beneficiarios.length
        }, { emitEvent: false });
      }
    }

    this.actualizarValidacionRutsBeneficiarios();
    this.invalidateCartSubscription();
    this.cerrarFormularioBeneficiario();
  }

  public eliminarBeneficiario(index: number): void {
    const control = this.beneficiarios.at(index);

    if (!control) {
      return;
    }

    control.reset({
      rut: '',
      email: '',
      nombre: '',
      primerApellido: '',
      segundoApellido: '',
      fechaNacimiento: ''
    });

    if (this.indexBeneficiarioEditando === index) {
      this.cerrarFormularioBeneficiario();
    }

    this.invalidateCartSubscription();
  }

  // =========================================================
  // LIMPIAR FORMULARIO
  // =========================================================

  public abrirModalLimpiar(): void {
    this.mostrarModalLimpiar = true;
  }

  public cerrarModalLimpiar(): void {
    this.mostrarModalLimpiar = false;
  }

  public limpiarFormulario(): void {
    this.inscripcionForm.reset({
      titular: {
        plan: '',
        rut: '',
        email: '',
        nombre: '',
        primerApellido: '',
        segundoApellido: '',
        fechaNacimiento: '',
        telefonoCodigo: '56',
        telefono: '',
        direccion: '',
        comuna: '',
        ciudad: '',
        ejecutivo: ''
      },
      beneficiariosDecision: {
        deseaAgregarBeneficiarios: null,
        momentoAgregarBeneficiarios: null,
        cantidadBeneficiariosDespues: null,
        agregarBeneficiariosAhora: false
      },
      planTerminos: {
        observaciones: '',
        aceptaTerminos: false,
        aceptaDeclaracion: false
      },
      validacion: {
        identidadValidada: false,
        firmaCompletada: false,
        autentikarInstanceId: '',
        autentikarLink: '',
        autentikarStatus: 'PENDIENTE'
      },
      pago: {
        metodoPago: '',
        autorizaPlanilla: false,
        pagoInscrito: false,
        tokenPago: '',
        preapprovalId: ''
      }
    });

    while (this.beneficiarios.length > 0) {
      this.beneficiarios.removeAt(0);
    }

    this.selectedAreaCode = {
      cou_phone_code: '56',
      cou_flag: 'fi-cl',
      cou_min_phone: 9,
      cou_max_phone: 9
    };

    this.setTelefonoValidators(this.selectedAreaCode);

    this.inscripcionForm.markAsPristine();
    this.inscripcionForm.markAsUntouched();

    this.mostrarModalLimpiar = false;
    this.showSuccessMessage = false;
    this.showSuccessPaymentScreen = false;
    this.showFailedPaymentScreen = false;
    this.loadingPaymentReturn = false;
    this.paymentStatusResponse = null;
    this.paymentReturnMessage = '';
    this.paymentReturnProviderName = '';
    this.paymentSubscriptionResponse = null;
    this.cartFromUrlResponse = null;
    this.cartSubscriptionResponse = null;
    this.cartSubscriptionPayload = null;
    this.updateCartStepResponse = null;
    this.lastCartPayloadHash = '';

    this.clearTitularRutValidationTimeout();
    this.resetTitularPlanValidationState();

    this.goToStep1();
  }

  // =========================================================
  // AUTENTICACIÓN / PAGO DEMO
  // =========================================================

  public iniciarAutenticacionDemo(): void {
    this.autenticarData.estado = 'PENDIENTE';

    this.validacionForm.patchValue({
      autentikarLink: this.autenticarData.link,
      autentikarStatus: 'PENDIENTE',
      identidadValidada: false,
      firmaCompletada: false
    });
  }

  public copiarLinkValidacion(): void {
    const link = this.autenticarData.link;

    if (navigator?.clipboard) {
      navigator.clipboard.writeText(link);
    }
  }

  public simularValidacionCompletada(): void {
    this.autenticarData.estado = 'VALIDADO';

    this.validacionForm.patchValue({
      identidadValidada: true,
      firmaCompletada: true,
      autentikarStatus: 'SUCCESS'
    });

    Swal.fire({
      icon: 'success',
      title: 'Validación completada',
      text: 'La identidad y firma fueron marcadas como validadas para continuar el flujo.',
      confirmButtonText: 'Aceptar'
    });
  }

  public seleccionarMetodoPago(metodo: string): void {
    const metodoHabilitado = (metodo === 'MERCADO_PAGO' && this.canUseMercadoPago()) || (metodo === 'VIRTUAL_POS' && this.canUseVirtualPos());
    if (!metodoHabilitado) {
      return;
    }
    const metodoPagoCtrl = this.pagoForm.get('metodoPago');
    metodoPagoCtrl?.setValue(metodo);
    metodoPagoCtrl?.markAsTouched();
    metodoPagoCtrl?.updateValueAndValidity();
  }

  // =========================================================
  // CARRO DE SUSCRIPCIÓN
  // =========================================================

  private invalidateCartSubscription(): void {
    if (this.restoringCartFromUrl) {
      return;
    }

    /*
      Si el usuario vuelve al Step 2 y modifica datos, no se debe perder
      el token del carro ya creado. postUpdateCartSubscription se usa solo
      para cambiar estados; los cambios de data se envían nuevamente por
      postCreateCartSubscription incluyendo tokenCart.
    */
    this.updateCartStepResponse = null;
    this.lastCartPayloadHash = '';
  }

  private cleanRutForPayload(rut: any): string {
    return (rut || '').toString().replace(/\./g, '').trim();
  }

  private getTelefonoCompletoTitular(): string {
    const titular = this.titularForm.value;
    const codigo = (titular.telefonoCodigo || '').toString().replace('+', '');
    const telefono = (titular.telefono || '').toString().replace(/\D/g, '');

    if (!codigo && !telefono) {
      return '';
    }

    return `+${codigo}${telefono}`;
  }

  private getAmountBeneficiario(index: number): number {
    if (index === 0) {
      return this.getPrecioCarga1Plan();
    }

    return this.getPrecioCarga2Plan();
  }

  private getPersonTypeBeneficiario(index: number): string {
    return `CARGA_${index + 1}`;
  }

  public buildCreateCartSubscriptionPayload(): any {
    const titular = this.titularForm.getRawValue();
    const planSeleccionado = this.getPlanSeleccionado();
    const sellerSelected = this.getSellerSelected();
    const cantidadTitulares = 1;
    const cantidadBeneficiarios = this.getCantidadBeneficiariosActual();

    const beneficiariosPayload = this.getDeseaAgregarBeneficiarios() === 'SI'
      ? this.getBeneficiariosCompletadosControls().map((item) => {
        const beneficiario = item.control.value;

        return {
          car_det_person_type: this.getPersonTypeBeneficiario(item.index),
          car_det_rut: this.cleanRutForPayload(beneficiario.rut),
          car_det_email: beneficiario.email || null,
          car_det_name: beneficiario.nombre,
          car_det_paternal_surname: beneficiario.primerApellido,
          car_det_maternal_surname: beneficiario.segundoApellido || '',
          car_det_phone: null,
          car_det_birthdate: beneficiario.fechaNacimiento || null,
          car_det_is_holder: false,
          car_det_amount: this.getAmountBeneficiario(item.index)
        };
      })
      : [];

    return {
      datosPlan: {
        car_id_plan: Number(planSeleccionado?.cus_ben_id || titular.plan),
        car_origin: 'PATIENT',
        car_total_amount: this.getTotalPlanMensual(),
        car_qty_titulares: cantidadTitulares,
        car_qty_beneficiarios: cantidadBeneficiarios
      },

      datosPacsTitular: {
        car_det_person_type: 'TITULAR',
        car_det_rut: this.cleanRutForPayload(titular.rut),
        car_det_email: titular.email,
        car_det_name: titular.nombre,
        car_det_paternal_surname: titular.primerApellido,
        car_det_maternal_surname: titular.segundoApellido || '',
        car_det_phone: this.getTelefonoCompletoTitular(),
        car_det_birthdate: titular.fechaNacimiento,
        car_det_is_holder: true,
        car_det_amount: this.getPrecioTitularPlan()
      },

      datosPacsBeneficiarios: beneficiariosPayload,

      datosVendedor: {
        car_seller_id: sellerSelected?.use_id || null,
        car_seller_name: sellerSelected?.use_name || 'Sin ejecutivo'
      }
    };
  }

  private getCartPayloadHash(payload: any): string {
    return JSON.stringify(payload);
  }

  private actualizarUrlConTokenCarro(tokenCart: string): void {
    if (!tokenCart) {
      return;
    }

    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const index = pathParts.indexOf('inscripcionConvenio');

    const basePath = index >= 0
      ? '/' + pathParts.slice(0, index + 1).join('/')
      : '/#/inscripcionConvenio';

    const nuevaUrl = `${basePath}/${tokenCart}`;

    if (window.location.pathname !== nuevaUrl) {
      window.history.replaceState({}, '', nuevaUrl);
    }
  }

  public async crearCarroSuscripcionDesdeStep2(): Promise<boolean> {
    if (this.creatingCartSubscription) {
      return false;
    }

    const payloadBase = this.buildCreateCartSubscriptionPayload();
    const payloadHash = this.getCartPayloadHash(payloadBase);
    const tokenCart = this.getTokenCartSubscription();

    /*
      Si ya existe token y el payload no cambió, no es necesario llamar
      ninguna API. Solo se avanza al paso de términos.
    */
    if (tokenCart && this.lastCartPayloadHash === payloadHash) {
      return true;
    }

    /*
      postCreateCartSubscription siempre recibe token:
      - Nueva transacción: token: ''
      - Modificación de carro existente: token: tokenCart
    */
    const payloadParaEnviar = {
      ...payloadBase,
      token: tokenCart || ''
    };

    this.creatingCartSubscription = true;

    Swal.fire({
      allowOutsideClick: false,
      html: `<div style="margin: 40px 0;">
                <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
                <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">
                  ${tokenCart ? 'Cargando detalles del plan ...' : 'Cargando detalles del plan ...'}
                </h1>
             </div>`,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const resp: any = await this.inscripcionService.postCreateUpdateCartSubscription(payloadParaEnviar);

      this.cartSubscriptionResponse = this.normalizarRespuestaCarro(resp, tokenCart);
      this.cartSubscriptionPayload = payloadBase;
      this.lastCartPayloadHash = payloadHash;

      const tokenGenerado = this.getTokenCartSubscription();
      this.actualizarUrlConTokenCarro(tokenGenerado);

      console.log('Payload postCreateUpdateCartSubscription:', payloadParaEnviar);
      console.log('Respuesta postCreateUpdateCartSubscription:', resp);

      Swal.close();

      return true;

    } catch (error) {
      console.error('Error postCreateUpdateCartSubscription:', error);

      Swal.close();

      const defaultTitle = tokenCart
        ? 'No fue posible guardar los cambios'
        : 'No fue posible crear el carro';

      const defaultMessage = 'Revisa la información ingresada e intenta nuevamente.';

      Swal.fire({
        icon: 'error',
        title: this.getBackendErrorTitle(error, defaultTitle),
        text: this.getBackendErrorMessage(error, defaultMessage),
        confirmButtonText: 'Aceptar'
      });

      return false;

    } finally {
      this.creatingCartSubscription = false;
    }
  }

  private getBackendErrorMessage(error: any, defaultMessage: string): string {
    if (!error) {
      return defaultMessage;
    }

    if (error?.error?.message) {
      return error.error.message;
    }

    if (error?.error?.data?.message) {
      return error.error.data.message;
    }

    if (error?.message) {
      return error.message;
    }

    if (typeof error?.error === 'string') {
      try {
        const parsedError = JSON.parse(error.error);

        if (parsedError?.message) {
          return parsedError.message;
        }
      } catch (_) {
        return error.error;
      }
    }

    return defaultMessage;
  }

  private getBackendErrorTitle(error: any, defaultTitle: string): string {
    const message = this.getBackendErrorMessage(error, '');

    if (error?.status === 400 && message === 'El titular ya tiene el plan contratado') {
      return 'Plan ya contratado';
    }

    return defaultTitle;
  }

  private normalizarRespuestaCarro(resp: any, tokenAnterior: string): any {
    const tokenRespuesta = this.getTokenFromResponse(resp);

    if (tokenRespuesta || !tokenAnterior) {
      return resp;
    }

    return {
      ...(resp || {}),
      tokenCart: tokenAnterior
    };
  }

  private getTokenFromResponse(response: any): string {
    return response?.token
      || response?.tokenCart
      || response?.token_cart
      || response?.token
      || response?.car_token
      || response?.sub_car_token
      || response?.data?.tokenCart
      || response?.data?.token_cart
      || response?.data?.token
      || response?.data?.car_token
      || response?.data?.sub_car_token
      || response?.data?.sub_car_token_cart
      || response?.result?.tokenCart
      || response?.result?.token_cart
      || response?.result?.token
      || response?.result?.car_token
      || response?.result?.sub_car_token
      || response?.cart?.tokenCart
      || response?.cart?.token_cart
      || response?.cart?.token
      || '';
  }

  private getTokenCartSubscription(): string {
    return this.getTokenFromResponse(this.cartSubscriptionResponse || {});
  }

  public buildUpdateCartSubscriptionPayload(stepCart: number): any {
    return {
      tokenCart: this.getTokenCartSubscription(),
      stepCart
    };
  }

  public async actualizarCarroSuscripcionStep(stepCart: number): Promise<boolean> {
    if (this.updatingCartStep) {
      return false;
    }

    const payload = this.buildUpdateCartSubscriptionPayload(stepCart);

    if (!payload.tokenCart) {
      Swal.fire({
        icon: 'warning',
        title: 'Token del carro no encontrado',
        text: 'No fue posible obtener el token del carro creado. Vuelve al paso anterior e intenta nuevamente.',
        confirmButtonText: 'Aceptar'
      });

      return false;
    }

    this.updatingCartStep = true;

    Swal.fire({
      allowOutsideClick: false,
      html: `<div style="margin: 40px 0;">
                <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
                <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">
                  Cargando medios de pago ...
                </h1>
             </div>`,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const resp: any = await this.inscripcionService.postUpdateStatusCart(payload);

      this.updateCartStepResponse = resp;

      console.log('Payload postUpdateStatusCart:', payload);
      console.log('Respuesta postUpdateStatusCart:', resp);

      Swal.close();

      return true;

    } catch (error) {
      console.error('Error postUpdateStatusCart:', error);

      Swal.close();

      Swal.fire({
        icon: 'error',
        title: 'No fue posible actualizar el carro',
        text: 'No se pudo registrar el avance de la inscripción. Intenta nuevamente.',
        confirmButtonText: 'Aceptar'
      });

      return false;

    } finally {
      this.updatingCartStep = false;
    }
  }

  // =========================================================
  // FINALIZAR FLUJO / MERCADO PAGO
  // =========================================================

  private markMercadoPagoRedirectSession(): void {
    try {
      sessionStorage.setItem(
        this.MERCADO_PAGO_REDIRECT_SESSION_KEY,
        'true'
      );
    } catch (error) {
      console.warn(
        'No fue posible guardar el estado de redirección a Mercado Pago:',
        error
      );
    }
  }

  private hasMercadoPagoRedirectSession(): boolean {
    try {
      return sessionStorage.getItem(
        this.MERCADO_PAGO_REDIRECT_SESSION_KEY
      ) === 'true';
    } catch (_) {
      return false;
    }
  }

  private clearMercadoPagoRedirectSession(): void {
    try {
      sessionStorage.removeItem(
        this.MERCADO_PAGO_REDIRECT_SESSION_KEY
      );
    } catch (_) {
      // No bloqueamos el flujo si sessionStorage no está disponible.
    }
  }

  /**
   * Libera el botón después de volver desde Mercado Pago
   * o después de un error al intentar redirigir.
   */
  private resetMercadoPagoRedirectState(): void {
    this.loadingSubmit = false;
    this.clearMercadoPagoRedirectSession();

    /*
     * Si el navegador restauró la página desde memoria,
     * también podría conservar abierto el loader de SweetAlert.
     */
    Swal.close();
  }

  public async enviarFormulario(): Promise<void> {
    await this.enviarFormulariodemo();
  }

  public async enviarFormulariodemo(): Promise<void> {
    if (this.loadingSubmit) {
      return;
    }
    this.markStep5Touched();
    if (!this.isStep5Valid()) {
      Swal.fire({ icon: 'warning', title: 'Autorización pendiente', text: 'Debes seleccionar un método de pago disponible y autorizar la modalidad de pago para finalizar la inscripción.', confirmButtonText: 'Aceptar' });
      return;
    }
    if (!this.cartSubscriptionResponse) {
      const carroCreado = await this.crearCarroSuscripcionDesdeStep2();
      if (!carroCreado) {
        return;
      }
    }
    const tokenCart = this.getTokenCartSubscription() || this.getTokenCartFromUrl();
    if (!tokenCart) {
      Swal.fire({ icon: 'warning', title: 'Token del carro no encontrado', text: 'No fue posible obtener el token del carro de compra. Intenta nuevamente.', confirmButtonText: 'Aceptar' });
      return;
    }
    const metodoPago = this.pagoForm.get('metodoPago')?.value;
    const esVirtualPos = metodoPago === 'VIRTUAL_POS';
    const nombreMetodoPago = esVirtualPos ? 'Virtual Pos' : 'Mercado Pago';
    this.loadingSubmit = true;
    Swal.fire({ allowOutsideClick: false, html: `<div style="margin: 40px 0;"><i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i><h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">Redirigiendo a ${nombreMetodoPago} ...</h1></div>`, showConfirmButton: false, didOpen: () => Swal.showLoading() });
    try {
      const payload = { token_cart: tokenCart };
      const resp: any = esVirtualPos ? await this.inscripcionService.postComenzarPagoVP(payload) : await this.inscripcionService.postComenzarPago(payload);
      console.log(`Payload ${esVirtualPos ? 'postComenzarPagoVP' : 'postComenzarPago'}:`, payload);
      console.log(`Respuesta ${esVirtualPos ? 'postComenzarPagoVP' : 'postComenzarPago'}:`, resp);
      if (!resp?.redirect_url) {
        Swal.close();
        Swal.fire({ icon: 'error', title: 'No fue posible iniciar el pago', text: resp?.message || `El backend no devolvió una URL válida para redirigir a ${nombreMetodoPago}.`, confirmButtonText: 'Aceptar' });
        this.loadingSubmit = false;
        return;
      }
      Swal.close();
      if (!esVirtualPos) {
        this.markMercadoPagoRedirectSession();
      }
      window.location.assign(resp.redirect_url);
      this.loadingSubmit = false;
    } catch (error) {
      console.error(`Error ${esVirtualPos ? 'postComenzarPagoVP' : 'postComenzarPago'}:`, error);
      this.resetMercadoPagoRedirectState();
      Swal.fire({ icon: 'error', title: 'Error al iniciar el pago', text: `Ocurrió un problema al comenzar el pago con ${nombreMetodoPago}. Intenta nuevamente.`, confirmButtonText: 'Aceptar' });
    }
  }

  private getUrlParam(paramName: string): string {
    const hash = window.location.hash || '';
    const queryIndex = hash.indexOf('?');

    if (queryIndex >= 0) {
      const hashQuery = hash.substring(queryIndex + 1);
      const hashParams = new URLSearchParams(hashQuery);
      const valueFromHash = hashParams.get(paramName);

      if (valueFromHash) {
        return valueFromHash;
      }
    }

    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(paramName) || '';
  }

  private getPreapprovalIdFromUrl(): string {
    return this.getUrlParam('preapproval_id');
  }

  private getTipoPagoFromUrl(): string {
    return (this.getUrlParam('tipoPago') || '').toString().trim().toLowerCase();
  }

  private getSubscripcionIdFromUrl(): string {
    return this.getUrlParam('subscripcion_id') || this.getUrlParam('subscription_id') || '';
  }

  private normalizarEstadoPago(value: any): string {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase();
  }

 private getEstadoPagoFromResponse(resp: any): string {
  return this.normalizarEstadoPago(
    resp?.status
    || resp?.data?.status
    || resp?.subscription?.status
    || resp?.suscription?.status
    || resp?.virtual_pos_subscription?.status
    || resp?.virtualPosSubscription?.status
    || resp?.preapproval?.status
    || resp?.mercado_pago_preapproval?.status
    || resp?.payment_status
    || resp?.preapproval_status
    || ''
  );
}

private isPaymentAuthorizedStatus(status: string): boolean {
  return [
    'authorized',
    'approved',
    'active',
    'activa',
    'paid',
    'pagado',
    'success',
    'completed',
    'completado'
  ].includes(this.normalizarEstadoPago(status));
}

private isPaymentRejectedStatus(status: string): boolean {
  return [
    'rejected',
    'rechazada',
    'rechazado',
    'cancelled',
    'canceled',
    'cancelada',
    'cancelado',
    'failed',
    'failure',
    'fallida',
    'fallido',
    'expired',
    'expirada',
    'expirado',
    'paused',
    'pausada',
    'pausado',
    'inactive',
    'inactiva',
    'suspended',
    'suspendida'
  ].includes(this.normalizarEstadoPago(status));
}

  private async procesarRetornoMercadoPago(preapprovalId: string): Promise<void> {
    console.log('Inicio procesarRetornoMercadoPago:', preapprovalId);

    /*
     * El usuario volvió mediante la URL oficial de retorno,
     * por lo que ya no existe una redirección pendiente.
     */
    this.clearMercadoPagoRedirectSession();
    this.loadingSubmit = false;

    this.loading = true;
    this.loadingPaymentReturn = true;
    this.paymentReturnProviderName = 'Mercado Pago';
    this.showSuccessPaymentScreen = false;
    this.showFailedPaymentScreen = false;
    this.paymentReturnMessage = '';
    this.paymentStatusResponse = null;

    try {
      /*
        Cargamos la información del convenio para mantener logos,
        teléfono y correo en la pantalla final.
      */
      await this.getInfoConvenio();

      /*
        IMPORTANTE:
        getStatusPayment recibe ÚNICAMENTE preapproval_id.
        El frontend ya no depende de token_cart después de volver
        desde Mercado Pago.
      */
      const payload = {
        preapproval_id: preapprovalId
      };

      console.log('Llamando getPreAprovallMercadoPago:', payload);

      const resp: any = await this.inscripcionService.getPreAprovallMercadoPago(payload);

      console.log('Respuesta getPreAprovallMercadoPago:', resp);

      this.paymentStatusResponse = resp;

      const status = this.getEstadoPagoFromResponse(resp);

      console.log('Estado normalizado Mercado Pago:', status);

      /*
        Para considerar el flujo exitoso:
        - El backend no debe informar ok === false.
        - Mercado Pago debe retornar un estado autorizado/aprobado.
      */
      if (resp?.ok !== false && this.isPaymentAuthorizedStatus(status)) {
        this.aplicarResultadoPagoExitoso(resp);
        return;
      }

      /*
        Si Mercado Pago respondió con un estado rechazado o con cualquier
        estado distinto de autorizado, mostramos la pantalla fallida.
      */
      const message = resp?.message
        || (this.isPaymentRejectedStatus(status)
          ? 'El pago o la autorización de la suscripción no fue aprobada.'
          : 'La suscripción no pudo ser confirmada. Intenta nuevamente.');

      this.aplicarResultadoPagoFallido(message);

    } catch (error) {
      console.error('Error procesando retorno Mercado Pago:', error);

      const message = this.getBackendErrorMessage(
        error,
        'Ocurrió un problema al validar la suscripción con Mercado Pago.'
      );

      this.aplicarResultadoPagoFallido(message);

    } finally {
      this.loadingPaymentReturn = false;
      this.loading = false;
      this.loadingSubmit = false;
    }
  }

  private async procesarRetornoVirtualPos(subscripcionId: string): Promise<void> {
    console.log('Inicio procesarRetornoVirtualPos:', subscripcionId);

    this.loadingSubmit = false;
    this.loading = true;
    this.loadingPaymentReturn = true;
    this.paymentReturnProviderName = 'Virtual Pos';
    this.showSuccessPaymentScreen = false;
    this.showFailedPaymentScreen = false;
    this.paymentReturnMessage = '';
    this.paymentStatusResponse = null;

    try {
      await this.getInfoConvenio();

      const payload = {
        subscription_id: subscripcionId
      };

      console.log('Llamando getSubscripcionVirtualPos:', payload);

      const resp: any = await this.inscripcionService.getSubscripcionVirtualPos(payload);

      console.log('Respuesta getSubscripcionVirtualPos:', resp);

      this.paymentStatusResponse = resp;

      const status = this.getEstadoPagoFromResponse(resp);

      console.log('Estado normalizado Virtual Pos:', status);

      if (resp?.ok !== false && this.isPaymentAuthorizedStatus(status)) {
        this.aplicarResultadoPagoExitoso(resp);
        return;
      }

      const message = resp?.message
        || (this.isPaymentRejectedStatus(status)
          ? 'El pago o la autorización de la suscripción en Virtual Pos no fue aprobada.'
          : 'La suscripción de Virtual Pos no pudo ser confirmada. Intenta nuevamente.');

      this.aplicarResultadoPagoFallido(message);
    } catch (error) {
      console.error('Error procesando retorno Virtual Pos:', error);

      const message = this.getBackendErrorMessage(
        error,
        'Ocurrió un problema al validar la suscripción con Virtual Pos.'
      );

      this.aplicarResultadoPagoFallido(message);
    } finally {
      this.loadingPaymentReturn = false;
      this.loading = false;
      this.loadingSubmit = false;
    }
  }

  private aplicarResultadoPagoExitoso(resp: any): void {
    this.paymentStatusResponse = resp;

    this.loading = false;
    this.loadingPaymentReturn = false;
    this.loadingCartFromUrl = false;
    this.loadingSubmit = false;

    this.currentStep = this.getPagoStep();

    this.steps = {
      seleccionPlan: false,
      titular: false,
      beneficiarios: false,
      planTerminos: false,
      validacion: false,
      pago: false,
      resumen: false
    };

    this.paymentReturnMessage = '';
    this.showFailedPaymentScreen = false;
    this.showSuccessPaymentScreen = true;
  }

  private aplicarResultadoPagoFallido(message: string): void {
    this.loading = false;
    this.loadingPaymentReturn = false;
    this.loadingCartFromUrl = false;
    this.loadingSubmit = false;

    this.currentStep = this.getPagoStep();

    this.steps = {
      seleccionPlan: false,
      titular: false,
      beneficiarios: false,
      planTerminos: false,
      validacion: false,
      pago: false,
      resumen: false
    };

    this.paymentReturnMessage = message
      || 'El pago o la autorización de la suscripción no fue aprobada.';

    this.showSuccessPaymentScreen = false;
    this.showFailedPaymentScreen = true;
  }

  // =========================================================
  // RESTAURAR CARRO DESDE URL
  // =========================================================

  private getTokenCartFromUrl(): string {
    const tokenParam = this.route.snapshot.paramMap.get('token')
      || this.route.snapshot.queryParamMap.get('token')
      || this.route.snapshot.queryParamMap.get('token_cart')
      || '';

    if (tokenParam) {
      return tokenParam;
    }

    const hashPath = (window.location.hash || '').split('?')[0];
    const hashParts = hashPath.replace(/^#\/?/, '').split('/').filter(Boolean);
    const hashRouteIndex = hashParts.indexOf('inscripcionConvenio');

    if (hashRouteIndex >= 0 && hashParts[hashRouteIndex + 1]) {
      return decodeURIComponent(hashParts[hashRouteIndex + 1]);
    }

    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const lastSegment = pathParts[pathParts.length - 1] || '';

    if (
      lastSegment
      && lastSegment !== 'inscripcionConvenio'
      && lastSegment !== 'inscripcionConvenio-ejecutivo'
    ) {
      return lastSegment;
    }

    return '';
  }

  private async cargarCarroSuscripcionDesdeUrl(tokenCart: string): Promise<void> {
    if (!tokenCart || this.loadingCartFromUrl) {
      return;
    }

    this.loadingCartFromUrl = true;
    this.restoringCartFromUrl = true;
    this.isCartFromUrl = true;

    try {
      const payload = {
        token_cart: tokenCart
      };

      const resp: any = await this.inscripcionService.getCartSubscription(payload);

      this.cartFromUrlResponse = resp;

      const cartData = this.normalizarCarroDesdeApi(resp, tokenCart);

      if (!cartData) {
        this.redirigirAInscripcionBase();
        return;
      }

      this.cartSubscriptionResponse = this.normalizarRespuestaCarro(cartData, tokenCart);
      this.patchFormularioDesdeCarro(cartData);

      const payloadActual = this.buildCreateCartSubscriptionPayload();

      this.cartSubscriptionPayload = payloadActual;
      this.lastCartPayloadHash = this.getCartPayloadHash(payloadActual);

      this.actualizarUrlConTokenCarro(this.getTokenCartSubscription());

      const stepToShow = this.getStepToShowFromCart(cartData);

      if (!this.showSuccessPaymentScreen && !this.showFailedPaymentScreen) {
        this.setStep(stepToShow);
      }

      // console.log('Estado carro recuperado:', cartData?.status || cartData?.sub_car_sta_id || cartData?.datosPlan?.status);
      // console.log('Step calculado para mostrar:', stepToShow);
      // console.log('Payload getCartSubscription:', payload);
      // console.log('Carro recuperado desde URL:', resp);

    } catch (error) {
      console.error('Error getCartSubscription:', error);

      /*
        Si se ingresa con una URL que trae solo token_cart y el backend
        no puede recuperar el carro, no mostramos el Swal de error.
        En ese caso volvemos a la URL base para iniciar nuevamente
        el proceso de inscripción:
        #/inscripcionConvenio
      */
      this.redirigirAInscripcionBase();
      return;

    } finally {
      this.loadingCartFromUrl = false;
      this.restoringCartFromUrl = false;
    }
  }

  private normalizarCarroDesdeApi(resp: any, tokenCart: string): any {
    const data = resp?.data || resp?.cart || resp?.result || resp;

    if (!data) {
      return null;
    }

    return {
      ...data,
      token: data?.token
        || data?.tokenCart
        || data?.token_cart
        || data?.sub_car_token
        || tokenCart,
      stepCart: data?.stepCart
        || data?.step_cart
        || data?.sub_car_step
        || data?.sub_car_step_cart
        || data?.cart_step
        || data?.datosPlan?.stepCart
        || data?.datosPlan?.step_cart
        || 2,
      datosPlan: data?.datosPlan || data?.plan || data?.datos_plan || {},
      datosPacsTitular: data?.datosPacsTitular
        || data?.titular
        || data?.datos_pacs_titular
        || {},
      datosPacsBeneficiarios: data?.datosPacsBeneficiarios
        || data?.beneficiarios
        || data?.datos_pacs_beneficiarios
        || [],
      datosVendedor: data?.datosVendedor
        || data?.vendedor
        || data?.datos_vendedor
        || {}
    };
  }

  private patchFormularioDesdeCarro(cartData: any): void {
    const datosPlan = cartData?.datosPlan || {};
    const titular = cartData?.datosPacsTitular || {};
    const beneficiarios = Array.isArray(cartData?.datosPacsBeneficiarios)
      ? cartData.datosPacsBeneficiarios
      : [];
    const vendedor = cartData?.datosVendedor || {};

    const sellerId = vendedor?.car_seller_id
      || vendedor?.use_id
      || vendedor?.seller_id
      || vendedor?.sub_car_seller_id
      || null;

    const sellerName = vendedor?.car_seller_name
      || vendedor?.use_name
      || vendedor?.seller_name
      || vendedor?.sub_car_seller_name
      || 'Ejecutivo asignado';

    if (sellerId) {
      this.sellerLockedFromCart = {
        use_id: sellerId,
        use_name: sellerName
      };
      this.ensureSellerFromCartExists();
      this.titularForm.get('ejecutivo')?.enable({ emitEvent: false });
    } else {
      this.sellerLockedFromCart = null;
      this.titularForm.get('ejecutivo')?.enable({ emitEvent: false });
    }

    const planId = datosPlan?.car_id_plan
      || datosPlan?.sub_car_plan_id
      || datosPlan?.plan_id
      || datosPlan?.cus_ben_id
      || this.titularForm.get('plan')?.value
      || '';

    this.titularForm.patchValue({
      plan: planId,
      rut: titular?.car_det_rut || titular?.rut || '',
      email: titular?.car_det_email || titular?.email || '',
      nombre: titular?.car_det_name || titular?.nombre || '',
      primerApellido: titular?.car_det_paternal_surname || titular?.primerApellido || '',
      segundoApellido: titular?.car_det_maternal_surname || titular?.segundoApellido || '',
      fechaNacimiento: this.toInputDate(titular?.car_det_birthdate || titular?.fechaNacimiento),
      ejecutivo: sellerId || ''
    }, { emitEvent: false });

    if (sellerId) {
      this.titularForm.get('ejecutivo')?.disable({ emitEvent: false });
    }

    this.patchTelefonoDesdeCarro(titular?.car_det_phone || titular?.telefono || '');

    this.limpiarBeneficiariosSlots();

    const cantidadDesdeCarro = Number(
      datosPlan?.car_qty_beneficiarios
      || datosPlan?.sub_car_qty_beneficiarios
      || cartData?.car_qty_beneficiarios
      || cartData?.sub_car_qty_beneficiarios
      || beneficiarios.length
      || 0
    );

    const maxIndexBeneficiarios = beneficiarios.reduce((maxIndex: number, beneficiario: any, index: number) => {
      const personType = beneficiario?.car_det_person_type || beneficiario?.person_type || '';
      const match = personType.toString().match(/CARGA_(\d+)/i);
      const slotIndex = match ? Number(match[1]) - 1 : index;

      return Math.max(maxIndex, slotIndex);
    }, -1);

    const cantidadBeneficiarios = Math.max(cantidadDesdeCarro, maxIndexBeneficiarios + 1);

    if (cantidadBeneficiarios > 0) {
      this.crearBeneficiariosSlots(cantidadBeneficiarios);
    }

    beneficiarios.forEach((beneficiario: any, index: number) => {
      const personType = beneficiario?.car_det_person_type || beneficiario?.person_type || '';
      const match = personType.toString().match(/CARGA_(\d+)/i);
      const slotIndex = match ? Number(match[1]) - 1 : index;

      if (slotIndex >= 0 && slotIndex < this.beneficiarios.length) {
        this.beneficiarios.at(slotIndex).patchValue({
          rut: beneficiario?.car_det_rut || beneficiario?.rut || '',
          email: beneficiario?.car_det_email || beneficiario?.email || '',
          nombre: beneficiario?.car_det_name || beneficiario?.nombre || '',
          primerApellido: beneficiario?.car_det_paternal_surname || beneficiario?.primerApellido || '',
          segundoApellido: beneficiario?.car_det_maternal_surname || beneficiario?.segundoApellido || '',
          fechaNacimiento: this.toInputDate(beneficiario?.car_det_birthdate || beneficiario?.fechaNacimiento)
        }, { emitEvent: false });
      }
    });

    this.beneficiariosDecisionForm.patchValue({
      deseaAgregarBeneficiarios: cantidadBeneficiarios > 0 ? 'SI' : null,
      momentoAgregarBeneficiarios: cantidadBeneficiarios > 0 ? 'AHORA' : null,
      cantidadBeneficiariosDespues: cantidadBeneficiarios > 0 ? cantidadBeneficiarios : null,
      agregarBeneficiariosAhora: cantidadBeneficiarios > 0
    }, { emitEvent: false });

    this.inscripcionForm.markAsPristine();
    this.inscripcionForm.markAsUntouched();
  }

  private toInputDate(value: any): string {
    if (!value) {
      return '';
    }

    if (typeof value === 'string' && value.length >= 10) {
      return value.substring(0, 10);
    }

    const date = new Date(value);

    if (isNaN(date.getTime())) {
      return '';
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  private patchTelefonoDesdeCarro(phone: string): void {
    const cleanPhone = (phone || '').toString().replace(/\D/g, '');

    if (!cleanPhone) {
      return;
    }

    const areaCode = this.areaCodes.find((item: any) => {
      return cleanPhone.startsWith(String(item.cou_phone_code));
    });

    if (areaCode) {
      const code = String(areaCode.cou_phone_code);
      const phoneWithoutCode = cleanPhone.substring(code.length);

      this.selectedAreaCode = areaCode;

      this.titularForm.patchValue({
        telefonoCodigo: code,
        telefono: phoneWithoutCode
      }, { emitEvent: false });

      this.setTelefonoValidators(areaCode);
      return;
    }

    this.titularForm.patchValue({
      telefono: cleanPhone
    }, { emitEvent: false });
  }

  private getStepToShowFromCart(cartData: any): number {
    const statusCart = Number(
      cartData?.status
      || cartData?.sub_car_sta_id
      || cartData?.cart_status
      || cartData?.datosPlan?.status
      || cartData?.datosPlan?.sub_car_sta_id
      || 0
    );

    this.showSuccessPaymentScreen = false;
    this.showFailedPaymentScreen = false;

    switch (statusCart) {
      case 131:
      case 132:
        // 131 CREATED / 132 PENDING_PATIENT_CONFIRMATION
        // El carro ya existe, pero aún debe aceptar términos.
        return 4;

      case 133:
        // 133 PENDING_IDENTITY_CONFIRMATION
        // Si Autentika está activo, continúa en validación.
        // Si no está activo, se salta directo a inscripción de pago.
        return this.canValidateAutentika ? 5 : this.getPagoStep();

      case 134:
        // 134 PENDING_PAYMENT
        // Debe continuar en inscripción de pago.
        return this.getPagoStep();

      case 135:
        // 135 COMPLETED
        // Pago autorizado / inscripción finalizada.
        this.currentStep = this.getPagoStep();
        this.steps = {
          seleccionPlan: false,
          titular: false,
          beneficiarios: false,
          planTerminos: false,
          validacion: false,
          pago: false,
          resumen: false
        };
        this.showSuccessPaymentScreen = true;
        return this.getPagoStep();

      default:
        break;
    }

    // Fallback para respuestas antiguas que no traigan status del carro,
    // pero sí stepCart / step_cart.
    const stepCart = Number(cartData?.stepCart || 2);

    if (stepCart <= 1) {
      return 2;
    }

    if (stepCart === 2) {
      return 4;
    }

    if (stepCart === 3) {
      return this.canValidateAutentika ? 5 : this.getPagoStep();
    }

    if (stepCart === 4) {
      return this.getPagoStep();
    }

    if (stepCart >= 5) {
      this.currentStep = this.getPagoStep();
      this.steps = {
        seleccionPlan: false,
        titular: false,
        beneficiarios: false,
        planTerminos: false,
        validacion: false,
        pago: false,
        resumen: false
      };
      this.showSuccessPaymentScreen = true;
      return this.getPagoStep();
    }

    return 2;
  }


  private redirigirAInscripcionBase(): void {

    const baseUrl = `${window.location.origin}/#/inscripcionConvenio`;

    // console.log('Redirigiendo a inscripción base:', baseUrl);

    window.location.replace(baseUrl);
  }

  // =========================================================
  // CONTACTO / HELPERS
  // =========================================================

  public irAlInicio(): void {
    window.location.href = '/';
  }

  public reiniciarInscripcion(): void {
    const baseUrl = `${window.location.origin}/#/inscripcionConvenio`;

    console.log('Reiniciando inscripción:', baseUrl);

    window.location.replace(baseUrl);
  }

  public contactarAlmamedis(): void {
    window.location.href = 'mailto:soporte@almamedis.cl';
  }

  public maskEmail(email: string): string {
    if (!email) {
      return '';
    }

    const [localPart, domainPart] = email.split('@');

    if (!domainPart) {
      return email;
    }

    const visibleLocal = localPart.slice(0, 3);
    const maskedLocal = `${visibleLocal}*****`;

    const [domainName, tld] = domainPart.split('.');
    const visibleDomain = domainName.slice(0, 4);
    const maskedDomain = `${visibleDomain}**`;

    return `${maskedLocal}@${maskedDomain}${tld ? '.' + tld : ''}`;
  }

  public especialidadesExpandidasPorPlan: { [key: string]: boolean } = {};

  private getPlanCardKey(plan: any): string {
    return String(plan?.cus_ben_id || plan?.id || plan?.cus_ben_name || '');
  }

  public isEspecialidadesPlanExpanded(plan: any): boolean {
    const key = this.getPlanCardKey(plan);
    return this.especialidadesExpandidasPorPlan[key] === true;
  }

  public toggleEspecialidadesPlan(plan: any, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }

    const key = this.getPlanCardKey(plan);

    if (!key) {
      return;
    }

    this.especialidadesExpandidasPorPlan[key] = !this.especialidadesExpandidasPorPlan[key];
  }

  public getEspecialidadesVisiblesPlan(plan: any): any[] {
    const especialidades = this.getEspecialidadesPlan(plan);

    if (this.isEspecialidadesPlanExpanded(plan)) {
      return especialidades;
    }

    return especialidades.slice(0, 3);
  }

  public getEspecialidadesOcultasCount(plan: any): number {
    const total = this.getEspecialidadesPlan(plan).length;

    return total > 3 ? total - 3 : 0;
  }

  public getDatosPagoMercadoPago(): any {
    return this.paymentStatusResponse?.datosPago?.payment || null;
  }

  public getProximoMontoPago(): number {
    return Number(
      this.getDatosPagoMercadoPago()?.next_payment_amount || 0
    );
  }

  public getProximaFechaPago(): string {
    const value = this.getDatosPagoMercadoPago()?.next_payment_date;

    if (!value) {
      return '—';
    }

    /*
      Evitamos desfases por zona horaria tomando directamente YYYY-MM-DD.
    */
    const rawDate = value.toString().substring(0, 10);
    const parts = rawDate.split('-');

    if (parts.length !== 3) {
      return '—';
    }

    const year = Number(parts[0]);
    const month = Number(parts[1]);
    const day = Number(parts[2]);

    if (!year || !month || !day) {
      return '—';
    }

    const date = new Date(year, month - 1, day);

    return date.toLocaleDateString('es-CL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  public getMedioPagoMercadoPago(): string {
    const method = (
      this.getDatosPagoMercadoPago()?.sub_pay_payment_method || ''
    )
      .toString()
      .trim()
      .toLowerCase();

    const methods: { [key: string]: string } = {
      visa: 'Visa',
      master: 'Mastercard',
      mastercard: 'Mastercard',
      amex: 'American Express',
      debvisa: 'Visa Débito',
      debmaster: 'Mastercard Débito'
    };

    return methods[method]
      || (method ? method.toUpperCase() : 'Mercado Pago');
  }

  public getPreapprovalIdPago(): string {
    return this.paymentStatusResponse?.preapproval_id
      || this.getDatosPagoMercadoPago()?.sub_pay_token
      || '';
  }

  
}